// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-11T19:03:03.104Z
// Property: Oasis (ID: 6767906449167733)
// Collections: 86 amenities, 7 floorplans (live), 63 photos, 75 POIs, 5 reviews, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167733",
  "property_external_id": "gvktesx",
  "property_zillow_url": "https://www.zillow.com/apartments/tampa-fl/maa-breakwater/CrVKCQ/",
  "property_apartments_url": "https://www.apartments.com/maa-breakwater-tampa-fl/gvktesx/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "oasis",
  "property_name": "Oasis",
  "property_website_url": "https://oasis-demo-theme.multiscreensite.com/",
  "property_domain": null,
  "property_address": "100 Beachfront Ave",
  "property_full_address": "100 Beachfront Ave, Tampa, FL 33611",
  "property_address_1": "100 Beachfront Ave",
  "property_address_2": null,
  "property_address_city": "Tampa",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33611",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "Sun Bay South",
  "property_address_latitude": "27.8860984",
  "property_address_longitude": "-82.5401189",
  "property_email": null,
  "property_phone": "123-456-7890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Waterfront Tampa living, beautifully framed.</strong> Set along the tranquil shores of Tampa Bay, Oasis pairs bay-view apartments with a bayside clubhouse, boardwalk strolls, and panoramic mornings—an elevated place to call home.</p>",
  "property_long_description": "<p><strong>Waterfront South Tampa living starts here.</strong> At Oasis, you can settle into a bayfront address in Sun Bay South with direct access to the boardwalk, a boat dock with slips and lifts, kayak launch and storage, and open-air spaces made for taking in Tampa Bay sunsets.</p><p>Choose from studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with modern finishes like quartz countertops, stainless steel appliances, island kitchens, high ceilings, in-home washer and dryer, vinyl plank flooring, walk-in showers, balconies, and select water or St. Pete skyline views. Beyond your door, <a href=\"/amenities\">resort-style amenities</a> include a bayfront saltwater pool with cabanas, rooftop terrace, fitness center, yoga studio, coworking space, conference rooms, outdoor kitchens, fire pits, sand volleyball, gated access, EV charging, and pet-friendly conveniences including a play area and wash station.</p><p>From your South Tampa base, you’re close to Westshore Marina District dining, Salt Shack on the Bay, Duckweed Urban Grocery, Picnic Island Park, Ballast Point, Gandy Bridge, Hyde Park Village, Tampa Riverwalk, and Gulf Coast beaches.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2bc5-7188-8bd2-769ce46a0a06.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "01a03a32-2bc5-7188-8bd2-769ce46a0a06",
    "storage_key": "property/6767906449167733/01a03a32-2bc5-7188-8bd2-769ce46a0a06.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "495",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.36363636363636",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "450",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "15",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed, maximum 2 pets per unit. No breed or weight restrictions.",
  "property_pet_policy_description": "Cats and dogs allowed, maximum 2 pets per unit. One-time pet fee: $450 per pet. Monthly pet rent: $15 per pet. No breed or weight restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-eb69-708d-8fe4-1b4d36b3cd68.webp",
  "property_primary_logo_media": {
    "alt_text": "Oasis Homes logo in yellow script font with a red-orange shadow on a black background.",
    "public_id": "01a03a30-eb69-708d-8fe4-1b4d36b3cd68",
    "storage_key": "property/6767906449167733/01a03a30-eb69-708d-8fe4-1b4d36b3cd68.webp",
    "width": 1080,
    "height": 1080
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-eb69-708d-8fe4-1b4d36b3cd68.webp",
  "property_secondary_logo_media": {
    "alt_text": "Oasis Homes logo in yellow script font with a red-orange shadow on a black background.",
    "public_id": "01a03a30-eb69-708d-8fe4-1b4d36b3cd68",
    "storage_key": "property/6767906449167733/01a03a30-eb69-708d-8fe4-1b4d36b3cd68.webp",
    "width": 1080,
    "height": 1080
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-3590-763e-b684-f9b37efdc271.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03a31-3590-763e-b684-f9b37efdc271",
    "storage_key": "property/6767906449167733/01a03a31-3590-763e-b684-f9b37efdc271.webp",
    "width": 210,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-2afd-76d5-a175-f3ea847c8ce1.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03a31-2afd-76d5-a175-f3ea847c8ce1",
    "storage_key": "property/6767906449167733/01a03a31-2afd-76d5-a175-f3ea847c8ce1.webp",
    "width": 210,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#27435d",
  "property_secondary_color": "#ea7f5e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "567 - 1,516 sq ft",
  "property_sqft_min": "567",
  "property_sqft_max": "1,516",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 18,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJey5BxSfdwogRUTslCKRrUHY",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Oasis",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p><strong>Waterfront amenities with everyday ease.</strong> At Oasis, bayfront living comes with a saltwater pool, kayak launch, boat dock, roof terrace, shaded cabanas, and direct boardwalk access. Grilling areas, fire pits, courtyard games, co-working spaces, a fitness center, yoga studio, EV charging, and pet-friendly perks round out a community designed for downtime, productivity, and Tampa waterfront views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room for your rhythm.</strong> Explore studio, one-, two-, and three-bedroom apartments at Oasis, where open-concept kitchens, quartz countertops, stainless steel appliances, high ceilings, and airy living spaces set a polished tone. Select floor plans add kitchen islands, built-in desks, mudroom entries, dual vanities, walk-in showers, balconies, or water views—bringing flexible Tampa living together with the waterfront energy of Sun Bay South.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Oasis from every angle.</strong> Preview bayfront days by the saltwater pool, cabanas at the water’s edge, marina views, and a roof terrace made for sunset scenes. Inside, see bright kitchens with quartz countertops, stainless steel appliances, airy living spaces, and balconies overlooking the water or courtyard. Browse the full gallery for a closer look.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Bay days, city access, South Tampa ease.</strong> From Oasis in Sun Bay South, Westshore Marina District dining, Duckweed Urban Grocery, Cru Cellars, and sunset stops like Salt Shack on the Bay are close by. Picnic Island Park adds beach time, disc golf, and open bay views, while Gandy Boulevard connects you to St. Pete, Bayshore Boulevard, Hyde Park, downtown Tampa, and the airport. Back home, waterfront amenities and boardwalk access keep the shoreline feeling close.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews keep coming back to the same Oasis standouts:</strong><br>breathtaking water views, well-kept amenity spaces, responsive maintenance, and a front office known for helpful communication. Feedback also highlights welcoming tours, quick answers, twice-monthly resident events, and a scenic walking area by the water. See why one review says, “the views never get old,” then read more firsthand experiences.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from the bay.</strong> From Oasis in Sun Bay South, you’re positioned where South Tampa’s shoreline energy meets everyday convenience. Head into Westshore Marina District for Duckweed Urban Grocery, Cru Cellars, coffee, and marina-side dining, or keep it casual at Salt Shack on the Bay when sunset calls.</p><p>Outdoor time is easy to build in: Picnic Island Park brings beach days, disc golf, and wide-open bay views nearby, while Gandy Boulevard and the bridge put St. Pete, Bayshore Boulevard, Hyde Park, downtown Tampa, and the airport within reach. Back at Oasis, waterfront <a href=\"/amenities\">community amenities</a> and direct boardwalk access make the neighborhood feel even closer—explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Sun Bay South address connects it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-forward living, right on the water.</strong> At Oasis, your day can move from a bayfront saltwater pool to a kayak launch, boat dock, roof terrace, or shaded cabana without leaving the community. Outdoor spaces are built for Florida downtime, with grilling areas, courtyard games, fire pits, a sundeck, and direct boardwalk access that keeps the waterfront close.</p><p>Inside, everyday convenience gets the same attention: co-working space and conference rooms, a fitness center with free weights, a yoga studio, package receiving, EV charging, bike and gear storage, and controlled-access entry. Pet-friendly features, including a play area and wash station, add another layer of ease. Explore the <a href=\"/gallery\">photo gallery</a>, review pet details on the <a href=\"/pet-policy\">pet policy</a> page, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Waterfront living starts here.</strong> Make your move to a Tampa apartment designed for comfort, elegance, and modern ease, with bay views, a bayside clubhouse, and a bay view boardwalk setting the scene. Start your online application today and take the next step toward calling MAA Breakwater home.</p>",
  "property_contactus_blurb": "<p><strong>Contact MAA Breakwater.</strong> Have questions or need directions? Our leasing team is here to help you explore waterfront living along Tampa Bay, from beautifully designed apartments with bay views to the bayside spaces that make this community feel elevated. Reach out today or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_faqs_blurb": "<p><strong>Questions about MAA Breakwater?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living along Tampa Bay. From waterfront views to bayside spaces, this FAQ page helps you plan with confidence—and the leasing team is happy to help with anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your rhythm.</strong> At Oasis, studio, one-, two-, and three-bedroom apartments give you clear options without sacrificing the polished details that make a home feel finished. Compare open-concept kitchens with quartz countertops and stainless steel appliances, airy living spaces with high ceilings, and select layouts with kitchen islands, built-in desks, mudroom entries, dual vanities, walk-in showers, balconies, or water views.</p><p>Whether you want a streamlined space or room to spread out, each floor plan is designed for easy everyday living in Tampa’s Sun Bay South area. Browse current availability, check pricing, and use the <a href=\"/gallery\">photo gallery</a> and <a href=\"/amenities\">amenities</a> to picture how your favorite layout connects to the waterfront lifestyle waiting outside your door.</p>",
  "property_gallery_blurb": "<p><strong>See Oasis in full color.</strong> Start with the scenes that set the tone: palms around the bayfront saltwater pool, cabanas beside the water, and marina views that carry from the dock to the roof terrace.</p><p>Inside the apartments, the gallery brings the details closer—bright kitchens with quartz countertops and stainless steel appliances, open living areas with high ceilings, and balconies that frame water, courtyard, or sunset views. You’ll also catch the everyday spaces that make the community feel complete, from the lounge and co-working areas to the fitness center, yoga studio, courtyard games, and places to rinse off gear or store a bike after time outside.</p><p>Browse the photos, explore more <a href=\"/amenities\">community amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Oasis in Tampa for yourself.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore waterfront living on the map.</strong> See available apartments at MAA Breakwater and get a feel for the Tampa Bay setting, from bay-view perspectives to the boardwalk and clubhouse moments that shape the community. Use the interactive map to picture what’s nearby and find your next home.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At Oasis, pet-friendly living is built into the daily routine—not treated like an afterthought. Dogs can burn off energy in the on-site pet play area, then clean up at the pet wash station before heading back upstairs. Cats get airy apartment spaces with balconies in select layouts, high ceilings, and sunny corners made for lounging.</p><p>With cats and dogs welcome, up to two pets per home, and no breed or weight restrictions, your search for pet-friendly apartments in Tampa gets simpler. When you want a change of scenery, nearby waterfront paths and the separate gated dog beach at Picnic Island Park add more ways to get outside. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Oasis fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share waterfront living.</strong> Invite friends to discover tranquil Tampa Bay views, beautifully designed apartments, a bayside clubhouse, and sunset strolls along the bay view boardwalk. If this is what you love about calling this community home, refer a friend and let them experience it for themselves.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access</strong><br>At MAA Breakwater, modern waterfront living is designed for ease. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to bay views, sunset strolls, and the comfort of home.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Oasis.</strong><br>Reviews highlight the everyday details that make life here feel easy: breathtaking water views, well-kept amenity spaces, a helpful front office, and maintenance that follows through. Residents also call out the leasing experience by name, noting smooth communication, welcoming tours, and quick answers when questions come up.</p><p>From twice-monthly resident events to a beautiful walking area by the water, the feedback points to a community with energy, care, and convenience. As one resident put it, “the views never get old.” Read the reviews below to hear firsthand what stands out at Oasis.</p>",
  "property_created_at": "1787682550602",
  "property_scheduletour_blurb": "<p><strong>See Tampa Bay living up close.</strong> Tour MAA Breakwater and take in waterfront views, beautifully designed apartments, the bayside clubhouse, and the bay view boardwalk in person. Schedule your visit today and experience the details that make living well feel effortless.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture waterfront living along Tampa Bay, with beautifully designed apartments, panoramic bay views, a bayside clubhouse, and a bay view boardwalk—all part of the comfort and modern elegance at MAA Breakwater.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview Oasis on your schedule.</strong> Start with the community tour to get a feel for the waterfront setting, then step into the fitness center and clubhouse to see the everyday spaces up close. Inside the apartment tours, move through Unit 1610, a one-bedroom layout, and a two-bedroom, two-bath layout at your own pace, pausing on details like open kitchens, sleek finishes, natural light, and balcony-connected living areas.</p><p>Use these virtual walkthroughs to compare flow, finishes, and sightlines before you choose your next step. When you are ready to see more, browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Oasis in Tampa in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Oasis",
  "property_seo_title_home": "Oasis |  Apartments in Tampa, FL",
  "property_seo_description_home": "Embrace the perfect blend of luxury and convenience at Oasis Tampa. Choose from spacious studios to three-bedroom apartments with resort-style amenities.",
  "property_seo_title_floorplans": "Floor Plans | Tampa, FL Apartments for Rent",
  "property_seo_description_floorplans": "Discover your perfect space at Oasis in Tampa! Explore stylish studios to roomy three-bedrooms. Find the layout that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Tampa, FL Apartments for Rent",
  "property_seo_description_amenities": "Live vibrantly at Oasis in Tampa, FL, featuring a saltwater pool, fitness center, and pet-friendly spaces that elevate your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Tampa, FL",
  "property_seo_description_gallery": "Discover life at Oasis in Tampa! Select from diverse floor plans and enjoy pet-friendly luxury amenities like saltwater pools and waterfront views.",
  "property_seo_title_virtualtours": "Virtual Tours | Oasis Apartments",
  "property_seo_description_virtualtours": "Step into your new lifestyle at Oasis in Tampa, FL. Take a virtual tour of our stunning studio, one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Oasis Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Oasis in Tampa, FL! Use our interactive map to discover spacious floor plans, resort-style amenities, and vibrant community living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tampa, FL",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Oasis in Tampa, FL! From local favorites to hidden gems, see what makes this community truly special.",
  "property_seo_title_contact": "Contact Us | Oasis",
  "property_seo_description_contact": "Connect with the Oasis team in Tampa, FL! Explore our studio to three-bedroom floor plans and get answers to all your apartment questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tampa, FL",
  "property_seo_description_faqs": "Uncover the answers to your questions at Oasis in Tampa, FL. From charming floor plans to pet-friendly amenities, dive into our FAQs for community insights!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tampa, FL",
  "property_seo_description_reviews": "Uncover the charm of Oasis in Tampa, FL. Hear firsthand from residents about our dog parks, swimming pool, and vibrant community life!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tampa, FL",
  "property_seo_description_applynow": "Unlock your perfect Oasis in Tampa! Choose from studio to three-bedroom homes, enjoy two dog parks, a refreshing pool, and nearby parks. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Oasis",
  "property_seo_description_residentaccess": "Experience convenience at Oasis in Tampa, FL! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Oasis",
  "property_seo_description_referafriend": "Great friends make great neighbors at Oasis in Tampa! Refer a friend today and enjoy exclusive rewards while building a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Oasis",
  "property_seo_description_scheduletour": "Experience the serenity of Oasis in Tampa, FL. Schedule a tour today and unveil your future home in a vibrant community designed for comfort and connection!",
  "property_seo_title_privacy": "Privacy Policy | Oasis",
  "property_seo_description_privacy": "At Oasis in Tampa, your privacy matters. Discover how we protect your information while you enjoy luxury living. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Oasis",
  "property_seo_description_accessibility": "Oasis in Tampa champions digital inclusion with our accessibility statement, ensuring everyone enjoys a seamless experience. Join us!",
  "property_seo_title_sitemap": "Sitemap | Oasis",
  "property_seo_description_sitemap": "Uncover all that Oasis in Tampa has to offer! Navigate our sitemap to find your perfect apartment and explore our vibrant community. Your dream home awaits!",
  "property_seo_title_thankyou": "Thank You | Oasis",
  "property_seo_description_thankyou": "Thank you for reaching out to Oasis in sunny Tampa! Our team will connect soon to help you start your journey to vibrant living and exceptional comfort.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tampa, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789049854302",
  "amenities": [
    {
      "id": "ec_b833c52c751e118446014a8b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e77a4787cd106f87e09f510",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c32296b981cd03f0487af271",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_132f45cd403c3578742e3821",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5435cf8288bbd2afd6597f7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ede4927519cdc938f70099ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_361847b354b43a88ce5bed75",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6147ba836357d5910288638",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b7f70f3a3c2a489f55d8083",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e4b15b6184bf5a01c2bc31",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_941b78a7c41702c317136197",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0befa863d0a212df5bfabc7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b0fac6ce49a50b6cd770ddb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81728329d3c8688eec8ecafb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4163810cb56bc9aa6eb3d457",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9c5e5e0e7e5925edea4135f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Roof Terrace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27cb17faf61ed5558d410bdb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Dock",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f281f8463b5e0539cbaef29c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bad8e3b6716d0a00b7c1b5fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dab41108669720188530a93c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_092460b053b45fb9ad5484d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2102a7b362af621067123243",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e6c0a66658c13175c8b9832",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Additional Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_badc8016b6a052a8ee450ff9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Bayfront Saltwater Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d0898fbf3c6a84e67f462a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Boat Dock",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5f6559ef09e02ea817e6374",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Boat Lifts And Boat Slips",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8cd3898f24256e91a98f35b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Building Marina",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97f860b9c44be8323309944a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Building Point",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0fd859594cc157517ddf4c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Building Sunset",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c75fc483b220c15fd0718991",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Desk",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcfa7b12012b50b6e00a6ece",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29398e5eb6e2d2f739b8a7df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11a39fb39b537f49bc1b3606",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Charcoal Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e517249f1f5a89979df89db8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Co Working Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c3dc3d05ddff0f3d8a55266",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1991ebc51d7e36fa6694ead8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access/gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f6d6014d0fb68b52d20434e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Corner Unit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b599b4469b7a28fa7c8e64a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39b71897ab3e56e9d3a1726f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bb37b58f77d7e9e8689ff7d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Direct Access To Boardwalk",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_136658cd7ce9b3f9f4e1c146",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Dual Vanities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d04931cf9539dc10f89de7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Ev Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04a6db8c08196964343dcc68",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Exterior Corner Balcony",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbd9ae3b3c6908b6039908e4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea145625487257eefcb1f444",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9d1a3e5a073c06fff7dbf9b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Gear Lounge With Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fc2d6fdbc942584c75422ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Handicap Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1951e3f39dd35ff64651203c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e24e99b256ad26ec93ad5731",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Interior Corner Balcony",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44376bd46b95dc53c499d313",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Kayak Launch",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10513c4774d83fcc5a11a319",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Kayak Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fafc1964ee7497c27af738e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a92793726ebd59c712c2acaa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Island Built-In Shelves",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d58d5b44969bfb1d8c95b5b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Balcony",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe6e90725d1f045a8c17c50",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Mudroom Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f7820dca454e46c1fcaa886",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Courtyard With Games",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab579750d04886cf2ea9433e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Grilling Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baf5989feba134ffd1b1fedf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Kitchen With Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58b12e4a375625da7ed1941b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b1404d69397b3d1140292d2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99fba529f2f2a800352da191",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Partial Water View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60991f98fca8bd56e4273363",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Friendly - No Breed Restrictions",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7bd03fcaaaa94f28f5cacfe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a8ac982771670eecc18be6d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d2ad3c570a46adfd7c29dd3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Resort-Style Saltwater Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ea827e9ace3ab90bac29c0c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74b01970a3518bdf1b91293c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "St Pete City View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7f63155ccbdb543a8bf2711",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Plank Throughout",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5785559f419138c568f79fa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Shower",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a695626ed81ac230695bf122",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Water View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_988021a242e2f880f082dc45",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Wine Cooler",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28e4d1ce046c4b655fffb7e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Burning Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d59a62a350b684f04b8949b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afda84f6996d026ae766dd07",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_153e5161ca0bf62484f38554",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b3510658aa3079e7158c9df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02ba09011bd86e291e73a22c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f1c4ca96c5058d50df5e184",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf09569b3f251f4db06c246a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0892b2f6af482bf466e69e48",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfab037c0915a5d1d6575ad9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c15afea91d5fb62f2f3c39d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e898772c8f2a8c98d4b9d415",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Island Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_275b454ff8423341c7af3998",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_565368fb697548f5b6f98bae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c28e75144914bd22a0bbc3a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1e6c9fe10c5f14f7ae0b520b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-31c0-7216-bdc0-7d3fa69118d3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a03a31-31c0-7216-bdc0-7d3fa69118d3",
        "storage_key": "property/6767906449167733/01a03a31-31c0-7216-bdc0-7d3fa69118d3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and cabanas, offering the perfect oasis for leisure and enjoyment.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PkZ1abGpFT2vlnHI00ySXfvhQvyW-zxCoLa_v3VeLL4/102/image.jpg"
    },
    {
      "id": "ec_a480914e893515d295d8e5e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-31c0-7216-bdc0-7d3fa69118d3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a03a31-31c0-7216-bdc0-7d3fa69118d3",
        "storage_key": "property/6767906449167733/01a03a31-31c0-7216-bdc0-7d3fa69118d3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and cabanas, offering the perfect oasis for leisure and enjoyment.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PkZ1abGpFT2vlnHI00ySXfvhQvyW-zxCoLa_v3VeLL4/102/image.jpg"
    },
    {
      "id": "ec_23445ab1385d4130d89fe492",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-1334-77cb-8c5e-3d427952b772.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, free weights, and benches.",
        "public_id": "01a03a31-1334-77cb-8c5e-3d427952b772",
        "storage_key": "property/6767906449167733/01a03a31-1334-77cb-8c5e-3d427952b772.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and free weights for a complete workout experience.",
      "link": "false",
      "alt_text": "Gym with weight machines, treadmills, free weights, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eA9bhJpVTJPmZwrJrCM_QaAee7_HZ_J6Us2spQYh4Tw/111/image.jpg"
    },
    {
      "id": "ec_a290faa49460a2a41d242785",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-13a7-7562-a85b-9f5d8830857a.webp",
      "image_media": {
        "alt_text": "Modern lounge area with bar seating and a kitchen.",
        "public_id": "01a03a31-13a7-7562-a85b-9f5d8830857a",
        "storage_key": "property/6767906449167733/01a03a31-13a7-7562-a85b-9f5d8830857a.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish lounge, featuring a full-service bar, comfortable seating, and entertainment screens.",
      "link": "false",
      "alt_text": "Modern lounge area with bar seating and a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2WdSDZpEgtmEjimU6UErQ9DrFtMLA2C3UQ_3tMrAxP4/102/image.jpg"
    },
    {
      "id": "ec_f9a464cbb9ed4e6a27295e0c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-3b03-755d-97fb-e241fb6a2686.webp",
      "image_media": {
        "alt_text": "Living room with a yellow bicycle mounted on a blue accent wall.",
        "public_id": "01a03a31-3b03-755d-97fb-e241fb6a2686",
        "storage_key": "property/6767906449167733/01a03a31-3b03-755d-97fb-e241fb6a2686.webp",
        "width": 1324,
        "height": 847
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a mounted bicycle, modern furniture, and decorative shelves, creating a vibrant and functional space.",
      "link": "false",
      "alt_text": "Living room with a yellow bicycle mounted on a blue accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/732VW7kQa_F5azB6XbOL8F6hlPf4KPqurBSY2sIo6bI/111/image.png"
    },
    {
      "id": "ec_b38fb990a130a010af0d398d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-27f6-75da-aabc-796a3e71312b.webp",
      "image_media": {
        "alt_text": "Hallway inside an apartment with doors leading to rooms.",
        "public_id": "01a03a31-27f6-75da-aabc-796a3e71312b",
        "storage_key": "property/6767906449167733/01a03a31-27f6-75da-aabc-796a3e71312b.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Walk through this apartment's hallway, featuring clean design and access to various living spaces.",
      "link": "false",
      "alt_text": "Hallway inside an apartment with doors leading to rooms.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/J9geLnaXH_PZXtmcAlr_jSKFXBO5Zk5T3ZkI9Sv_WWs/102/image.jpg"
    },
    {
      "id": "ec_48193ef445c989bce2d6b10b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-3fdb-72ea-8e99-beb6e821d0dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "01a03a31-3fdb-72ea-8e99-beb6e821d0dd",
        "storage_key": "property/6767906449167733/01a03a31-3fdb-72ea-8e99-beb6e821d0dd.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a large island, sleek white cabinetry, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/i-1iH5JmcMPQ0Ec5lq_W-024qawPgOpOyughd9ZzQsY/102/image.jpg"
    },
    {
      "id": "ec_49eda8d2eb53907c9bba83d3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-494d-7524-8713-6fb27d36f2ea.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower curtain.",
        "public_id": "01a03a31-494d-7524-8713-6fb27d36f2ea",
        "storage_key": "property/6767906449167733/01a03a31-494d-7524-8713-6fb27d36f2ea.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "View of a clean and modern bathroom featuring a single vanity with a sleek faucet, a white toilet, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/H5QQ_fF6sBkMd_T7vd_x90P5pZ6lLq1phSeVaMtuvg8/102/image.jpg"
    },
    {
      "id": "ec_f5c6d2da94f500158b530bfc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-5276-75ef-b8d5-b72c45e1d76e.webp",
      "image_media": {
        "alt_text": "Luxuriously appointed bedroom with a king-size bed, tasteful decor, and modern amenities.",
        "public_id": "01a03a31-5276-75ef-b8d5-b72c45e1d76e",
        "storage_key": "property/6767906449167733/01a03a31-5276-75ef-b8d5-b72c45e1d76e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a serene retreat in our spacious bedroom, featuring a plush king-size bed, elegant decor, and a tranquil atmosphere for ultimate relaxation.",
      "link": "false",
      "alt_text": "Luxuriously appointed bedroom with a king-size bed, tasteful decor, and modern amenities.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/edu6T2oixEJT8-DWylIAG36igG3DKwBD-Y-3lQ5ybGo/118/image.jpg"
    },
    {
      "id": "ec_616bc753b0239c4817c6f3df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-5924-717a-9249-3a355406ffbf.webp",
      "image_media": {
        "alt_text": "Balcony with water view, seating area, and outdoor pool visible below.",
        "public_id": "01a03a31-5924-717a-9249-3a355406ffbf",
        "storage_key": "property/6767906449167733/01a03a31-5924-717a-9249-3a355406ffbf.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Enjoy breathtaking water views from your private balcony, complete with comfortable seating and a glimpse of the resort-style pool.",
      "link": "false",
      "alt_text": "Balcony with water view, seating area, and outdoor pool visible below.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Bn8Xkp91XGErQLRbYTQFJAuS_LUHkgK_OaLOTqNaSqI/102/image.jpg"
    },
    {
      "id": "ec_0d267b7a99d23ad3a0ca019c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-50ed-7739-be7b-11990b0e3997.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, white cabinets, and subway tile backsplash.",
        "public_id": "01a03a31-50ed-7739-be7b-11990b0e3997",
        "storage_key": "property/6767906449167733/01a03a31-50ed-7739-be7b-11990b0e3997.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and functional apartment kitchen featuring stainless steel appliances, ample cabinet storage, and a sleek subway tile backsplash. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with stainless steel appliances, white cabinets, and subway tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rQDaBeMigRvxeKWeM14rtqnPuRdq8RZMdYIHZ67dHXk/118/image.jpg"
    },
    {
      "id": "ec_62833a90f7031d0204cf6870",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-646b-7706-859a-050f43ef0bc6.webp",
      "image_media": {
        "alt_text": "Modern living room with a yellow bicycle mounted on a blue wall, a leather sofa, and large windows.",
        "public_id": "01a03a31-646b-7706-859a-050f43ef0bc6",
        "storage_key": "property/6767906449167733/01a03a31-646b-7706-859a-050f43ef0bc6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living space featuring a unique wall-mounted bicycle display, comfortable seating, and abundant natural light from large windows.",
      "link": "false",
      "alt_text": "Modern living room with a yellow bicycle mounted on a blue wall, a leather sofa, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/P_ThdOSGSdt-6KxPUUM0_bMVEan-OzIGLls_rPRMc-E/102/image.jpg"
    },
    {
      "id": "ec_bcdc9b28e521745a1530ecd5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-5eab-745f-b97d-ac99df46b3bf.webp",
      "image_media": {
        "alt_text": "Empty room with a window and a door open to a bathroom.",
        "public_id": "01a03a31-5eab-745f-b97d-ac99df46b3bf",
        "storage_key": "property/6767906449167733/01a03a31-5eab-745f-b97d-ac99df46b3bf.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious empty room with a large window, wood-look flooring, and an adjacent bathroom.",
      "link": "false",
      "alt_text": "Empty room with a window and a door open to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WMrms-s9yzbehMWC2n8YHAuqXWI2k6QBqFytzwm6J2U/104/image.jpg"
    },
    {
      "id": "ec_9f5604abf406f7315048416d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-6ac2-7051-b963-a6d9502de538.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dual vanity, large mirror, soaking tub, and walk-in closet.",
        "public_id": "01a03a31-6ac2-7051-b963-a6d9502de538",
        "storage_key": "property/6767906449167733/01a03a31-6ac2-7051-b963-a6d9502de538.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience luxury in our modern bathrooms, featuring a spacious dual vanity, elegant fixtures, a deep soaking tub, and a generous walk-in closet for all your storage needs.",
      "link": "false",
      "alt_text": "Modern bathroom with a dual vanity, large mirror, soaking tub, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/E--FGDQbU8GL43t699czExSk87eN9_GFmOXP4H1-8lg/119/image.jpg"
    },
    {
      "id": "ec_f93ab65183d9e4b4ea9ddd11",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-6cbf-775d-9a7d-8aca31bd297b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-style flooring and a closet.",
        "public_id": "01a03a31-6cbf-775d-9a7d-8aca31bd297b",
        "storage_key": "property/6767906449167733/01a03a31-6cbf-775d-9a7d-8aca31bd297b.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring wood-style flooring, ample closet space, and a neutral color palette.",
      "link": "false",
      "alt_text": "Empty bedroom with wood-style flooring and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k_pe2RtX9VJh3pdQhQw6kmr1QabMsUCPu6mnc4futk4/104/image.jpg"
    },
    {
      "id": "ec_70221b2a911f01a7d5b054db",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-79e8-77a8-ba8e-92e4d87e5168.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile shower/tub, vanity with quartz countertop, and stainless steel fixtures.",
        "public_id": "01a03a31-79e8-77a8-ba8e-92e4d87e5168",
        "storage_key": "property/6767906449167733/01a03a31-79e8-77a8-ba8e-92e4d87e5168.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a spa-like experience in this elegant bathroom, featuring a deep soaking tub, sleek vanity with ample storage, and modern finishes.",
      "link": "false",
      "alt_text": "Modern bathroom with white subway tile shower/tub, vanity with quartz countertop, and stainless steel fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/v8ljvR44o3PLJwHH49wgSY3zF9rLqYjokzw8S67szAA/119/image.jpg"
    },
    {
      "id": "ec_fb7d6e5ddcd1abe931600067",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-799c-7194-8e12-7f7d4c0cfb36.webp",
      "image_media": {
        "alt_text": "Modern open-concept kitchen with island, stainless steel appliances, and large windows.",
        "public_id": "01a03a31-799c-7194-8e12-7f7d4c0cfb36",
        "storage_key": "property/6767906449167733/01a03a31-799c-7194-8e12-7f7d4c0cfb36.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience sleek, modern living in this stunning open-concept kitchen, featuring a spacious island, premium stainless steel appliances, and abundant natural light.",
      "link": "false",
      "alt_text": "Modern open-concept kitchen with island, stainless steel appliances, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5oW6o6d3QnpppHJheksu7sPapupBww0ArFQuZMTrCQE/104/image.jpg"
    },
    {
      "id": "ec_dc984cead7153a13632dbf13",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-808b-77be-b7e2-2654f3253b91.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees under a clear blue sky.",
        "public_id": "01a03a31-808b-77be-b7e2-2654f3253b91",
        "storage_key": "property/6767906449167733/01a03a31-808b-77be-b7e2-2654f3253b91.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, surrounded by lush palm trees and comfortable lounge seating. Perfect for relaxation and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8vN6FAObz4zlI8FxsVJDxJKjGpIBs8t_8syrVaipSBk/102/image.jpg"
    },
    {
      "id": "ec_05f90c0bb0e54f6ba442909d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-87ff-7524-a322-631bbffcb8d8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "01a03a31-87ff-7524-a322-631bbffcb8d8",
        "storage_key": "property/6767906449167733/01a03a31-87ff-7524-a322-631bbffcb8d8.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for relaxation and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ltBOjhWgMRlHdsR0bdyx5z9t_SBI7RB_To2cmpZGFBs/119/image.jpg"
    },
    {
      "id": "ec_15ff8aa2ffb9e125fbec0a67",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-8d6c-7240-ad5e-496b0bd39087.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with seating overlooking a swimming pool and the ocean.",
        "public_id": "01a03a31-8d6c-7240-ad5e-496b0bd39087",
        "storage_key": "property/6767906449167733/01a03a31-8d6c-7240-ad5e-496b0bd39087.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our expansive outdoor covered patio, featuring comfortable seating and stunning views of the swimming pool and ocean.",
      "link": "false",
      "alt_text": "Outdoor covered patio with seating overlooking a swimming pool and the ocean.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Tkb0ppefCwFqf4jsQYNK8r2Y9rIXkMdpoxUoP6tsIjE/102/image.jpg"
    },
    {
      "id": "ec_d757048923c5120e3a4ea9c4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-9855-70fd-aa76-b81da0ee7f24.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "01a03a31-9855-70fd-aa76-b81da0ee7f24",
        "storage_key": "property/6767906449167733/01a03a31-9855-70fd-aa76-b81da0ee7f24.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and a charming clubhouse.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HvK3csArYf3O_u955J7OgnJTKMZCNCIonxD44cYz4VA/119/image.jpg"
    },
    {
      "id": "ec_867ffe6b9ae0f66725c85f74",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-9a73-775c-a4e5-7ea371ab7666.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, nightstands, and mirrors. Opens to living area and kitchen with balcony.",
        "public_id": "01a03a31-9a73-775c-a4e5-7ea371ab7666",
        "storage_key": "property/6767906449167733/01a03a31-9a73-775c-a4e5-7ea371ab7666.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "A spacious and inviting bedroom featuring a king-size bed and elegant decor. The adjoining living area and kitchen offer access to a balcony with stunning views.",
      "link": "false",
      "alt_text": "Bedroom with king-size bed, nightstands, and mirrors. Opens to living area and kitchen with balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sM6SrCKTmvx-hRQ67dX0RCmORv3iugEM7qNDcDLuTjg/102/image.jpg"
    },
    {
      "id": "ec_3930c89f831ba21047f1e7ae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-a062-774e-b584-6e38cef4ad10.webp",
      "image_media": {
        "alt_text": "Living room with a teal accent wall, a bicycle mounted on the wall, a brown sofa, and large windows overlooking water.",
        "public_id": "01a03a31-a062-774e-b584-6e38cef4ad10",
        "storage_key": "property/6767906449167733/01a03a31-a062-774e-b584-6e38cef4ad10.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room featuring a bold teal accent wall with a mounted bicycle, a comfortable brown sofa, and abundant natural light from large windows offering serene water views.",
      "link": "false",
      "alt_text": "Living room with a teal accent wall, a bicycle mounted on the wall, a brown sofa, and large windows overlooking water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Sg9xME5u33RLnqQjeu2SGnp_eczh1LCFFV5M_FHdv78/119/image.jpg"
    },
    {
      "id": "ec_1e20742c8898ac0b2bc790b1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-a278-772d-9523-5d87c7c833be.webp",
      "image_media": {
        "alt_text": "Balcony with water view and outdoor seating",
        "public_id": "01a03a31-a278-772d-9523-5d87c7c833be",
        "storage_key": "property/6767906449167733/01a03a31-a278-772d-9523-5d87c7c833be.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Enjoy breathtaking water views from your private balcony, complete with comfortable outdoor seating for relaxation.",
      "link": "false",
      "alt_text": "Balcony with water view and outdoor seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SbUzgyYNjA3lUJ8dR9bJv3lJhYEzTVZxyXU0c5hVlVY/102/image.jpg"
    },
    {
      "id": "ec_cef5162e60eaf0c7f1d4d643",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-ad91-736c-a15f-a00c68377fab.webp",
      "image_media": {
        "alt_text": "Community room with a long table, kitchen counter, and a pool table.",
        "public_id": "01a03a31-ad91-736c-a15f-a00c68377fab",
        "storage_key": "property/6767906449167733/01a03a31-ad91-736c-a15f-a00c68377fab.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the community room, featuring a full kitchen, comfortable seating, and a pool table for resident use.",
      "link": "false",
      "alt_text": "Community room with a long table, kitchen counter, and a pool table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pISkgVhSzf3Ha82AOWprRdqkSXTn3xHmYIaiwvh5Ppk/119/image.jpg"
    },
    {
      "id": "ec_8084c7927ff88d7d85e824c9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-b7c8-74fd-9196-9b91a2e31679.webp",
      "image_media": {
        "alt_text": "Modern lounge area with nautical decor, fireplace, TV, and water views.",
        "public_id": "01a03a31-b7c8-74fd-9196-9b91a2e31679",
        "storage_key": "property/6767906449167733/01a03a31-b7c8-74fd-9196-9b91a2e31679.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a fireplace, and stunning waterfront views. A perfect space for socializing.",
      "link": "false",
      "alt_text": "Modern lounge area with nautical decor, fireplace, TV, and water views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TTVW2wR3MdWvrJ3l0wOzHJ6niLx78bnheuJWcBsMrOs/102/image.jpg"
    },
    {
      "id": "ec_2933f20bc588ccb831d7446c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-c795-736b-93e4-7bdb911bfd8d.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with a fireplace, TV, and comfortable seating.",
        "public_id": "01a03a31-c795-736b-93e4-7bdb911bfd8d",
        "storage_key": "property/6767906449167733/01a03a31-c795-736b-93e4-7bdb911bfd8d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Unwind in our beautifully appointed community lounge, featuring a contemporary fireplace, large screen TV, and plush seating areas perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Modern apartment community lounge with a fireplace, TV, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OhtbUDrE5fl_dII3Fffk8P6AxCpy6_OP7P9R8Dr6uoY/119/image.jpg"
    },
    {
      "id": "ec_0e2b855671e613a848f2fdbf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-c0a3-70aa-83fb-cd911406fac3.webp",
      "image_media": {
        "alt_text": "Modern lounge with fireplace, pool table, and ocean view.",
        "public_id": "01a03a31-c0a3-70aa-83fb-cd911406fac3",
        "storage_key": "property/6767906449167733/01a03a31-c0a3-70aa-83fb-cd911406fac3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a cozy fireplace, a fun pool table, and breathtaking ocean views.",
      "link": "false",
      "alt_text": "Modern lounge with fireplace, pool table, and ocean view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/j1Ouq3-dr26GNTpXaKqhGjXBcqdQOvCAMMu_jCUZPlE/102/image.jpg"
    },
    {
      "id": "ec_e3b0c0bb3a4384638fc37c66",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-c492-76bb-ac3b-3dafdf4aaed6.webp",
      "image_media": {
        "alt_text": "Community lounge area with dining table and chairs overlooking the water and palm trees.",
        "public_id": "01a03a31-c492-76bb-ac3b-3dafdf4aaed6",
        "storage_key": "property/6767906449167733/01a03a31-c492-76bb-ac3b-3dafdf4aaed6.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind in our elegant community lounge, featuring comfortable seating and stunning waterfront views.",
      "link": "false",
      "alt_text": "Community lounge area with dining table and chairs overlooking the water and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DzJJXNZ_-OTbFEza0PIURJlqCaiUvFFQHnHwuY6wQ1s/119/image.jpg"
    },
    {
      "id": "ec_763b1ad638652fd185ba5d5c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-c562-7286-afd1-06cb49a6a1d5.webp",
      "image_media": {
        "alt_text": "Modern conference room with large table and orange chairs, TV displaying a beach scene.",
        "public_id": "01a03a31-c562-7286-afd1-06cb49a6a1d5",
        "storage_key": "property/6767906449167733/01a03a31-c562-7286-afd1-06cb49a6a1d5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "A stylish conference room featuring a large table, comfortable seating, and a wall-mounted TV. Perfect for business meetings or collaborative work sessions.",
      "link": "false",
      "alt_text": "Modern conference room with large table and orange chairs, TV displaying a beach scene.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pkj6EEq_WEHIv5mIoabSIxQ8dvQUYbJGMcxXP0eYch4/102/image.jpg"
    },
    {
      "id": "ec_fe5784cba62d21e3422ca77b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-d6d9-75ab-bdbd-4dd96a2d7733.webp",
      "image_media": {
        "alt_text": "Community lounge with seating, pool table, foosball table, and water view.",
        "public_id": "01a03a31-d6d9-75ab-bdbd-4dd96a2d7733",
        "storage_key": "property/6767906449167733/01a03a31-d6d9-75ab-bdbd-4dd96a2d7733.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a game of pool or foosball in the community lounge, featuring comfortable seating and scenic water views.",
      "link": "false",
      "alt_text": "Community lounge with seating, pool table, foosball table, and water view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5qFX1pXTQ6U0qKlu--KkV5h9CE4aV6q6hm7g4YOatrE/119/image.jpg"
    },
    {
      "id": "ec_ad6181ea202d661c6741d2b8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-dbe1-71bf-a733-864aeb42de75.webp",
      "image_media": {
        "alt_text": "Ping pong table and lounge area with water views",
        "public_id": "01a03a31-dbe1-71bf-a733-864aeb42de75",
        "storage_key": "property/6767906449167733/01a03a31-dbe1-71bf-a733-864aeb42de75.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a game of ping pong or relax in the lounge area with beautiful water views.",
      "link": "false",
      "alt_text": "Ping pong table and lounge area with water views",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7p5zAJkW3yaZetZKt4RHb5AF9ZK7YnQr1JXTst03pIA/102/image.jpg"
    },
    {
      "id": "ec_4b3cd11a60cb6845bff54a86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-e42e-74b7-9fa0-e07f0f14f5b2.webp",
      "image_media": {
        "alt_text": "Community lounge with lockers, table, bar stools, shuffleboard and foosball.",
        "public_id": "01a03a31-e42e-74b7-9fa0-e07f0f14f5b2",
        "storage_key": "property/6767906449167733/01a03a31-e42e-74b7-9fa0-e07f0f14f5b2.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy resident amenities like this community lounge, complete with lockers, a game table, and a shuffleboard court.",
      "link": "false",
      "alt_text": "Community lounge with lockers, table, bar stools, shuffleboard and foosball.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WeBuzB09YQxBZI4dq2tGUYFFwd0ZM0dVk8ikgHZMHHE/119/image.jpg"
    },
    {
      "id": "ec_8de11f2fb58ca1c688392ea6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-e7e2-71bc-9849-899ca1a3543e.webp",
      "image_media": {
        "alt_text": "Courtyard with beach volleyball court, cornhole boards, and lounge chairs at a multifamily property.",
        "public_id": "01a03a31-e7e2-71bc-9849-899ca1a3543e",
        "storage_key": "property/6767906449167733/01a03a31-e7e2-71bc-9849-899ca1a3543e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation in the courtyard, featuring a beach volleyball court, cornhole, and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Courtyard with beach volleyball court, cornhole boards, and lounge chairs at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OJxHBiZs_qmUFJ4vEXY78kkcn7__Dc3dNl5W5HouRVE/102/image.jpg"
    },
    {
      "id": "ec_1c966a093b403f45ee262179",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-eac9-74ca-ae41-e1fa79af628e.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables, chairs, and grills under a shade sail, near palm trees and the apartment building.",
        "public_id": "01a03a31-eac9-74ca-ae41-e1fa79af628e",
        "storage_key": "property/6767906449167733/01a03a31-eac9-74ca-ae41-e1fa79af628e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling in our community's shaded patio area, perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor seating area with tables, chairs, and grills under a shade sail, near palm trees and the apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/e2Il1UnminiFiKHNV4633n8R7x-EVhNmOyKh3_xaBYE/119/image.jpg"
    },
    {
      "id": "ec_e651b5c3006b67fd99537788",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f5b9-74a5-9716-dae8030bcad2.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, ellipticals, and stationary bikes.",
        "public_id": "01a03a31-f5b9-74a5-9716-dae8030bcad2",
        "storage_key": "property/6767906449167733/01a03a31-f5b9-74a5-9716-dae8030bcad2.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines and weight equipment, perfect for an active lifestyle.",
      "link": "false",
      "alt_text": "Modern apartment gym with treadmills, ellipticals, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U04UYvToY3e_wVO2u7A7zDZWAZlLaBBYDE9v50aXwjI/102/image.jpg"
    },
    {
      "id": "ec_e8126cc1e6e1e84cc7b2a93e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-fd05-7494-b7f8-f2a41f72610c.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, weight machines, and free weights.",
        "public_id": "01a03a31-fd05-7494-b7f8-f2a41f72610c",
        "storage_key": "property/6767906449167733/01a03a31-fd05-7494-b7f8-f2a41f72610c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a wide array of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with treadmills, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/F8Km_lKLOgqD22nZtKDt4b-WpyShWd1CTf_1L4IE6c8/118/image.jpg"
    },
    {
      "id": "ec_22f98763e6675af6fd911ce4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-061c-73ca-9085-c487861967c4.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with weight machines, treadmills, and cardio equipment.",
        "public_id": "01a03a32-061c-73ca-9085-c487861967c4",
        "storage_key": "property/6767906449167733/01a03a32-061c-73ca-9085-c487861967c4.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay active and healthy in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Well-equipped gym with weight machines, treadmills, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/l-UXCExYSI9aOdI7s9V23NzBXRpmUkqcSmA5WzHmTsM/119/image.jpg"
    },
    {
      "id": "ec_2cfb9666aeeeb0fc5dac35f7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-029e-700d-afe7-cd8239792518.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines and weights, overlooking the water.",
        "public_id": "01a03a32-029e-700d-afe7-cd8239792518",
        "storage_key": "property/6767906449167733/01a03a32-029e-700d-afe7-cd8239792518.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and a boxing station with stunning waterfront views.",
      "link": "false",
      "alt_text": "Gym with cardio machines and weights, overlooking the water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EoQhaFl_l2K_g3NUBPudS3BM-QB_SrXCGLA7ii2jaCY/118/image.jpg"
    },
    {
      "id": "ec_b8a8cef707cfbfc6d68f2858",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-118b-74fc-95bc-43840c32dcf6.webp",
      "image_media": {
        "alt_text": "Resort-style pool area with palm trees and a modern clubhouse at sunset.",
        "public_id": "01a03a32-118b-74fc-95bc-43840c32dcf6",
        "storage_key": "property/6767906449167733/01a03a32-118b-74fc-95bc-43840c32dcf6.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the beautiful resort-style swimming pool and modern clubhouse at our community. Perfect for relaxing and socializing by the water.",
      "link": "false",
      "alt_text": "Resort-style pool area with palm trees and a modern clubhouse at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CraPecyaQKGEIZMDpuC-NFBCrFy5Wbrl1drzD8mTh68/102/image.jpg"
    },
    {
      "id": "ec_66ae45fe93e6e066736c5759",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-14f4-7049-b21d-24e5804e6c44.webp",
      "image_media": {
        "alt_text": "Beautifully landscaped roundabout with a heron sculpture in front of a clubhouse and apartment buildings at sunset.",
        "public_id": "01a03a32-14f4-7049-b21d-24e5804e6c44",
        "storage_key": "property/6767906449167733/01a03a32-14f4-7049-b21d-24e5804e6c44.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Welcome to your new home! Enjoy the amenities and beautiful surroundings of our community, featuring a clubhouse and modern apartment buildings.",
      "link": "false",
      "alt_text": "Beautifully landscaped roundabout with a heron sculpture in front of a clubhouse and apartment buildings at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iMsKxiEeeKKjg_5EmNsNysbMIRFDSRykuDh5n2XSGcs/118/image.jpg"
    },
    {
      "id": "ec_57e109c4505cbad933fd06dc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1fa5-7401-96ea-689abd545e43.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with granite countertops and stainless steel grills.",
        "public_id": "01a03a32-1fa5-7401-96ea-689abd545e43",
        "storage_key": "property/6767906449167733/01a03a32-1fa5-7401-96ea-689abd545e43.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our state-of-the-art grilling station, featuring high-quality stainless steel grills and elegant granite countertops.",
      "link": "false",
      "alt_text": "Outdoor grilling station with granite countertops and stainless steel grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FOYYjGyLkUYETfQhFk_xh2xWtZc6BGK3EzscwKWjDGo/102/image.jpg"
    },
    {
      "id": "ec_f64e696d4101f4035d5a678c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-40d2-73bf-a6d6-069365230b01.webp",
      "image_media": {
        "alt_text": "Waterfront promenade with seating and apartment buildings.",
        "public_id": "01a03a32-40d2-73bf-a6d6-069365230b01",
        "storage_key": "property/6767906449167733/01a03a32-40d2-73bf-a6d6-069365230b01.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the stunning waterfront views from the promenade. Relax on the benches or take a stroll along the water's edge at this beautiful community.",
      "link": "false",
      "alt_text": "Waterfront promenade with seating and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iSTRbDra2Tq97E2q8ATHk-LPk6xaSlJjggRtjePSh6o/119/image.jpg"
    },
    {
      "id": "ec_ceeb291f4b3afb873b890a19",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2ce4-73ca-acba-402e1eed2f58.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a resort-style pool and waterfront amenities.",
        "public_id": "01a03a32-2ce4-73ca-acba-402e1eed2f58",
        "storage_key": "property/6767906449167733/01a03a32-2ce4-73ca-acba-402e1eed2f58.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience luxury living at our waterfront community, featuring a sparkling pool, lush landscaping, and stunning ocean views. Your dream home awaits.",
      "link": "false",
      "alt_text": "Aerial view of a modern apartment complex with a resort-style pool and waterfront amenities.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yaAWVdbcy4pn-oyihZ3fqezZeyAW3pW-ZiNkE1amxCE/102/image.jpg"
    },
    {
      "id": "ec_cad1b2b6bbccc041999123ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2bc5-7188-8bd2-769ce46a0a06.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "01a03a32-2bc5-7188-8bd2-769ce46a0a06",
        "storage_key": "property/6767906449167733/01a03a32-2bc5-7188-8bd2-769ce46a0a06.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zV3gvmRpP3S_YkUSUCIj8xfc7ck_PnkCxREWixrw5Fs/119/image.jpg"
    },
    {
      "id": "ec_c473918fe125ff965c6ad9a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-30b9-762a-90ee-03cd01897758.webp",
      "image_media": {
        "alt_text": "Aerial view of a luxury apartment complex with a pool and waterfront access.",
        "public_id": "01a03a32-30b9-762a-90ee-03cd01897758",
        "storage_key": "property/6767906449167733/01a03a32-30b9-762a-90ee-03cd01897758.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover resort-style living at this stunning apartment community, featuring a sparkling pool and beautiful waterfront views.",
      "link": "false",
      "alt_text": "Aerial view of a luxury apartment complex with a pool and waterfront access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pcEXTpGfYfEe5L0JOo9iyQEnxp26kNq5WDAj6ECNijI/118/image.jpg"
    },
    {
      "id": "ec_7c4c9ef6a0ab990bbf10a5eb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-3d28-7387-814f-9cb233495eb0.webp",
      "image_media": {
        "alt_text": "Aerial view of modern waterfront apartment buildings with balconies and a large parking lot.",
        "public_id": "01a03a32-3d28-7387-814f-9cb233495eb0",
        "storage_key": "property/6767906449167733/01a03a32-3d28-7387-814f-9cb233495eb0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover elegant waterfront living with stunning views from these modern apartment buildings. Enjoy spacious balconies and convenient parking.",
      "link": "false",
      "alt_text": "Aerial view of modern waterfront apartment buildings with balconies and a large parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1-uz-vJuAk1SPOMUiQ8zdgKrU17ETDFakGZP79Hi3SI/113/image.jpg"
    },
    {
      "id": "ec_b505e39ae5e4d0dd32f61976",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-5571-703f-ab48-ea5472a4d6f1.webp",
      "image_media": {
        "alt_text": "Modern waterfront apartment buildings with balconies and views of the water.",
        "public_id": "01a03a32-5571-703f-ab48-ea5472a4d6f1",
        "storage_key": "property/6767906449167733/01a03a32-5571-703f-ab48-ea5472a4d6f1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stunning waterfront apartment buildings featuring contemporary architecture, private balconies, and breathtaking views of the water. Experience luxury living by the sea.",
      "link": "false",
      "alt_text": "Modern waterfront apartment buildings with balconies and views of the water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/joA1Jm_6twKEiE0w_Q07bRhhvAziFKJjxjVRRzVWQKI/102/image.jpg"
    },
    {
      "id": "ec_17aca837ed997151d6429172",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-5cd4-7196-8e2e-969d5b0a0a24.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with a water view and a heron sculpture in the foreground.",
        "public_id": "01a03a32-5cd4-7196-8e2e-969d5b0a0a24",
        "storage_key": "property/6767906449167733/01a03a32-5cd4-7196-8e2e-969d5b0a0a24.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to the stunning clubhouse, offering resort-style amenities and a beautiful waterfront setting.",
      "link": "false",
      "alt_text": "Exterior building entrance with a water view and a heron sculpture in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lZak94hjZ5YM1RiTUYYafbQza5Udb8oG_bE6EFN12Ls/119/image.jpg"
    },
    {
      "id": "ec_b3b54b0e00de2c2dd7c2c40c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-5a83-7407-91e5-0c29b8da3c87.webp",
      "image_media": {
        "alt_text": "MAA Breakwater monument sign and apartment buildings",
        "public_id": "01a03a32-5a83-7407-91e5-0c29b8da3c87",
        "storage_key": "property/6767906449167733/01a03a32-5a83-7407-91e5-0c29b8da3c87.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Welcome to MAA Breakwater, a premier apartment community. This image features the property's monument sign with landscaping and apartment buildings in the background.",
      "link": "false",
      "alt_text": "MAA Breakwater monument sign and apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1RRd4toAMf48WtOvuuufWtHlwNCmd6uCbfxYY51OliU/102/image.jpg"
    },
    {
      "id": "ec_3fd22c490d894fec631ffdd3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-56a6-7562-aa01-c264a24e35f8.webp",
      "image_media": {
        "alt_text": "Game room with shuffleboard, foosball table, lockers, and surfboards.",
        "public_id": "01a03a32-56a6-7562-aa01-c264a24e35f8",
        "storage_key": "property/6767906449167733/01a03a32-56a6-7562-aa01-c264a24e35f8.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy recreation and games in our community game room, featuring shuffleboard, foosball, and ample locker storage.",
      "link": "false",
      "alt_text": "Game room with shuffleboard, foosball table, lockers, and surfboards.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fqhra48fd42MqcPSWWFeQgDfVWKQ3QOgi4HUp9vcsZ0/102/image.jpg"
    },
    {
      "id": "ec_7dbc87cc2320758570db4848",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-6eb8-77ef-9e89-a35e1a28e448.webp",
      "image_media": {
        "alt_text": "Outdoor seating area on a balcony overlooking a bay with a boat and palm trees.",
        "public_id": "01a03a32-6eb8-77ef-9e89-a35e1a28e448",
        "storage_key": "property/6767906449167733/01a03a32-6eb8-77ef-9e89-a35e1a28e448.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the waterfront views from our stylish outdoor seating area, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Outdoor seating area on a balcony overlooking a bay with a boat and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vwHK0UX-ao_krpu25RuzaEEEIvYLcaFfrCUpVC0GV5g/119/image.jpg"
    },
    {
      "id": "ec_3f2261f946cb239e5c48c0bc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-7ffb-7009-8868-ea6ddaa94ec2.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with cardio machines, weight machines, dumbbells, and benches.",
        "public_id": "01a03a32-7ffb-7009-8868-ea6ddaa94ec2",
        "storage_key": "property/6767906449167733/01a03a32-7ffb-7009-8868-ea6ddaa94ec2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with cardio machines, weight machines, dumbbells, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/L8yspUuEMiWRdCUmwAtLnVIERP7-47IOW_Ccq3QkvVk/102/image.jpg"
    },
    {
      "id": "ec_d80f671e408eb38c16ba0ec0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-7baa-70eb-a464-d9ceb29a3186.webp",
      "image_media": {
        "alt_text": "A well-equipped fitness center with cardio machines, free weights, and a punching bag, overlooking a waterfront view.",
        "public_id": "01a03a32-7baa-70eb-a464-d9ceb29a3186",
        "storage_key": "property/6767906449167733/01a03a32-7baa-70eb-a464-d9ceb29a3186.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier cardio equipment, free weights, and a dedicated space for boxing or functional training. Enjoy your workout with stunning waterfront views.",
      "link": "false",
      "alt_text": "A well-equipped fitness center with cardio machines, free weights, and a punching bag, overlooking a waterfront view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IRwL_Ce4shkN8fPUaVYBFkVm_ntulDUWFli23e3Msyk/119/image.jpg"
    },
    {
      "id": "ec_414c6a45353cf01081f98158",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-a205-717b-8802-bd1cc77887c1.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with a long communal table, bar, seating area, and fireplace.",
        "public_id": "01a03a32-a205-717b-8802-bd1cc77887c1",
        "storage_key": "property/6767906449167733/01a03a32-a205-717b-8802-bd1cc77887c1.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience modern comfort in our expansive lounge, featuring a communal table, bar, cozy seating nooks, and a fireplace for relaxation.",
      "link": "false",
      "alt_text": "Spacious lounge area with a long communal table, bar, seating area, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iI9Nif04sxu5CnHx9RoLH2NUr2ysINQJOhmQIfK7hXA/119/image.jpg"
    },
    {
      "id": "ec_f41823e6d4246441a3e87376",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-87eb-720f-9fe6-abd527960ef5.webp",
      "image_media": {
        "alt_text": "Modern conference room with large windows, a table, and orange chairs.",
        "public_id": "01a03a32-87eb-720f-9fe6-abd527960ef5",
        "storage_key": "property/6767906449167733/01a03a32-87eb-720f-9fe6-abd527960ef5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Host your next meeting in our stylish conference room, featuring ample natural light and comfortable seating.",
      "link": "false",
      "alt_text": "Modern conference room with large windows, a table, and orange chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZwlqFDLO81unAh6jZIkZtfhyrYJTZoyvhOgASz9td7I/102/image.jpg"
    },
    {
      "id": "ec_d14fadec77bf8b2552dd5bd8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-8d1c-70cc-b0b4-8a7c387b3a36.webp",
      "image_media": {
        "alt_text": "Pool table in communal lounge with bar and water views.",
        "public_id": "01a03a32-8d1c-70cc-b0b4-8a7c387b3a36",
        "storage_key": "property/6767906449167733/01a03a32-8d1c-70cc-b0b4-8a7c387b3a36.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a game of pool in our resident lounge, featuring a full bar, comfortable seating, and scenic water views.",
      "link": "false",
      "alt_text": "Pool table in communal lounge with bar and water views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/wOILQhjLl43lmbO9YAuOBbnreESwsAu70kbqHynBB6I/119/image.jpg"
    },
    {
      "id": "ec_56c7f4ece22812397c91be36",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-a4b5-7312-8142-c2749f3b85f0.webp",
      "image_media": {
        "alt_text": "Private work suites with glass doors and wood-paneled walls.",
        "public_id": "01a03a32-a4b5-7312-8142-c2749f3b85f0",
        "storage_key": "property/6767906449167733/01a03a32-a4b5-7312-8142-c2749f3b85f0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Private work suites with glass doors, wood-paneled walls, and individual desks offer a quiet space for residents to focus.",
      "link": "false",
      "alt_text": "Private work suites with glass doors and wood-paneled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SX2lmPy52aDsiFju67lN7AzRx3BRUQqt4b5PE-nmNa8/102/image.jpg"
    },
    {
      "id": "ec_86912a3ac46d8ecfe91ab09c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-9daa-705c-bfa5-aa43fc208720.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a table and chairs overlooking a pool and the ocean.",
        "public_id": "01a03a32-9daa-705c-bfa5-aa43fc208720",
        "storage_key": "property/6767906449167733/01a03a32-9daa-705c-bfa5-aa43fc208720.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the ocean breeze from our covered outdoor seating area, complete with comfortable lounge furniture and dining tables. Perfect for relaxing or entertaining with stunning waterfront views.",
      "link": "false",
      "alt_text": "Outdoor seating area with a table and chairs overlooking a pool and the ocean.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/noYK_SKFvPc_mLCg2WU8EPRy3h8zLFrXvIbmyPu0d2o/119/image.jpg"
    },
    {
      "id": "ec_5d34da6ae9489550f5e5480f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-a32d-7759-95bf-5e2ee3af0b4c.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "01a03a32-a32d-7759-95bf-5e2ee3af0b4c",
        "storage_key": "property/6767906449167733/01a03a32-a32d-7759-95bf-5e2ee3af0b4c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, complete with comfortable lounge chairs and shaded cabanas, perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5VstS4bnBhpimcLjCCJ9XmR7uxIweWvxCL_CmBmP8tY/119/image.jpg"
    },
    {
      "id": "ec_cc7e0bb5218c670299243bca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-b029-73f7-a444-a4bb1f7f1273.webp",
      "image_media": {
        "alt_text": "Waterfront walkway with palm trees and modern apartment buildings.",
        "public_id": "01a03a32-b029-73f7-a444-a4bb1f7f1273",
        "storage_key": "property/6767906449167733/01a03a32-b029-73f7-a444-a4bb1f7f1273.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy scenic walks along the waterfront promenade, lined with palm trees and offering stunning ocean views from your apartment.",
      "link": "false",
      "alt_text": "Waterfront walkway with palm trees and modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zkADQPs3R_VsMjQyN9_4zsiMiGxHntAwXkzdvBMxC8w/102/image.jpg"
    },
    {
      "id": "ec_1007c98f408543fe756a1b00",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-c1ce-72fa-bab5-503712f373cf.webp",
      "image_media": {
        "alt_text": "Waterfront view with an outdoor area, featuring artificial turf, palm trees, and a paved walkway.",
        "public_id": "01a03a32-c1ce-72fa-bab5-503712f373cf",
        "storage_key": "property/6767906449167733/01a03a32-c1ce-72fa-bab5-503712f373cf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the waterfront views from this beautifully landscaped outdoor area, complete with lush artificial turf and tropical palm trees.",
      "link": "false",
      "alt_text": "Waterfront view with an outdoor area, featuring artificial turf, palm trees, and a paved walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/khDAYciaKBWs7e8_jzaa8BIGKoCSZkq5PjUpfCeJJ9A/119/image.jpg"
    },
    {
      "id": "ec_821382e8ee89f99b4eaf51ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-c4f3-714b-9c92-898a8eb50589.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "01a03a32-c4f3-714b-9c92-898a8eb50589",
        "storage_key": "property/6767906449167733/01a03a32-c4f3-714b-9c92-898a8eb50589.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by lush palm trees and comfortable lounge chairs, it's an oasis of tranquility.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_eYn9A1ONIybI5k4nhb985Zc1ZwHWZoNfntCGWEXNuM/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fcc783f31dfd29c0a8187cf3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Salt Shack On The Bay",
      "poi_type": "Restaurants",
      "poi_address": "5415 W Tyson Ave, Tampa, FL 33611, USA",
      "poi_short_description": "American bar food & drinks, specializing in seafood, in a chill setting with access by land or boat.",
      "poi_long_description": "American bar food & drinks, specializing in seafood, in a chill setting with access by land or boat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-07c8-76de-99f1-fe412ebc9e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-07c8-76de-99f1-fe412ebc9e7d",
        "storage_key": "property/6767906449167733/01a03a2f-07c8-76de-99f1-fe412ebc9e7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://salt-shack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17117473534066398472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-shack-on-the-bay",
      "poi_latitude": "27.8868649",
      "poi_longitude": "-82.5408932",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-444-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSwkNNXdwogRCJUtqnx7je0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_f4749654f559354e8c6e6cb6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Hula Bay Club",
      "poi_type": "Restaurants",
      "poi_address": "5210 W Tyson Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Bayside haunt for Hawaiian-style chow, featuring a lively poolside lounge & dockside dining.",
      "poi_long_description": "Bayside haunt for Hawaiian-style chow, featuring a lively poolside lounge & dockside dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f6b6-70ad-bd5c-f82989299032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f6b6-70ad-bd5c-f82989299032",
        "storage_key": "property/6767906449167733/01a03a31-f6b6-70ad-bd5c-f82989299032.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hulabayclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002413175749291894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hula-bay-club",
      "poi_latitude": "27.8854264",
      "poi_longitude": "-82.5345578",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-837-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz67_9RXdwogRdi8N166RLWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_a73813ef3890f47af0e51c8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Leons Lobstah Shack",
      "poi_type": "Restaurants",
      "poi_address": "5314 Interbay Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Casual eatery for lobster rolls and chowders, plus outdoor tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f9c4-7757-a12a-38a75f9b7302.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f9c4-7757-a12a-38a75f9b7302",
        "storage_key": "property/6767906449167733/01a03a31-f9c4-7757-a12a-38a75f9b7302.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.leonslobstah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8632709089526508257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leons-lobstah-shack",
      "poi_latitude": "27.8892183",
      "poi_longitude": "-82.4807952",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-831-2112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYyeVfndwogR4WqDyi2LzXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_93cbcbe47f618ec0309990b9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Big Ray's Fish Camp",
      "poi_type": "Restaurants",
      "poi_address": "6116 Interbay Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Compact counter serve featuring seafood & sandwiches in a casual space with a fishing-shack vibe.",
      "poi_long_description": "Compact counter serve featuring seafood & sandwiches in a casual space with a fishing-shack vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f4b9-7354-bd47-4eec892ed57d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f4b9-7354-bd47-4eec892ed57d",
        "storage_key": "property/6767906449167733/01a03a31-f4b9-7354-bd47-4eec892ed57d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bigraysfishcamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3104634433069176170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rays-fish-camp",
      "poi_latitude": "27.8793441",
      "poi_longitude": "-82.4952213",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-605-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cwtmpTcwogRatWIXJHgFSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_f9d7049aa89905979bebd91d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Tampa Bay Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "13937 Monroes Business Park, Tampa, FL 33635, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f64a-7503-8cab-02194547d413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f64a-7503-8cab-02194547d413",
        "storage_key": "property/6767906449167733/01a03a31-f64a-7503-8cab-02194547d413.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tbbc.beer/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4363709656004549196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-bay-brewing-company",
      "poi_latitude": "28.0382117",
      "poi_longitude": "-82.6475907",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 5 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 813-247-1422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95TBA4rrwogRTNoX7c8Cjzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_5bd6e506130aea60c0e78532",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Datz - Tampa",
      "poi_type": "Restaurants",
      "poi_address": "2616 S MacDill Ave, Tampa, FL 33629, USA",
      "poi_short_description": "Lively American gastropub providing updated comfort food & craft brews, plus gourmet groceries.",
      "poi_long_description": "Lively American gastropub providing updated comfort food & craft brews, plus gourmet groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f26e-72ad-90de-63a6d5d883ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f26e-72ad-90de-63a6d5d883ff",
        "storage_key": "property/6767906449167733/01a03a31-f26e-72ad-90de-63a6d5d883ff.webp",
        "width": 1200,
        "height": 567
      },
      "poi_business_url": "http://www.datztampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2822356438292015945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "datz---tampa",
      "poi_latitude": "27.9219495",
      "poi_longitude": "-82.493225",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 813-831-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1LgW0bDwogRSavuJToGKyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6f165a212857865ec615a399",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Barcelona Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "2907 W Bay to Bay Blvd Ste A100, Tampa, FL 33629, USA",
      "poi_short_description": "Casual tapas joint and wine bar with a menu inspired by Spain, as well as weekend brunch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f950-70fe-a29e-828e7db92786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f950-70fe-a29e-828e7db92786",
        "storage_key": "property/6767906449167733/01a03a31-f950-70fe-a29e-828e7db92786.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://barcelonawinebar.com/location/tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17723332985064219249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barcelona-wine-bar",
      "poi_latitude": "27.9202286",
      "poi_longitude": "-82.49142859999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-722-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_OEjj7DwogRcWK3mnLt9fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "ec_12d5b2e120b0697ba792e71b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "O-Ku",
      "poi_type": "Restaurants",
      "poi_address": "2907 W Bay to Bay Blvd, Tampa, FL 33629, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f635-73ee-907f-cf166f82788b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f635-73ee-907f-cf166f82788b",
        "storage_key": "property/6767906449167733/01a03a31-f635-73ee-907f-cf166f82788b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.o-kusushi.com/location/tampa/?y_source=1_MTA2Njk3NjQ4NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10870871433063895086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "o-ku",
      "poi_latitude": "27.9202037",
      "poi_longitude": "-82.491357",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 656-347-4117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzY7HwxfDwogRLhC31vgX3ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_2517ef7b3f90b863412c50c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "West Tampa Sandwich Shop",
      "poi_type": "Restaurants",
      "poi_address": "3904 N Armenia Ave, Tampa, FL 33607, USA",
      "poi_short_description": "Casual cafe turning out Cuban dishes & specialty sandwiches including one enhanced with honey.",
      "poi_long_description": "Casual cafe turning out Cuban dishes & specialty sandwiches including one enhanced with honey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f27e-76cb-bb64-85699f788d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f27e-76cb-bb64-85699f788d7b",
        "storage_key": "property/6767906449167733/01a03a31-f27e-76cb-bb64-85699f788d7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westtampasandwichshoprestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18159207425684387279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-tampa-sandwich-shop",
      "poi_latitude": "27.9734069",
      "poi_longitude": "-82.4850218",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 813-873-7104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbUnl43DwogRz7WNKvF2Avw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_201c4b11ab40d0e1d26e879a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Taste of China",
      "poi_type": "Restaurants",
      "poi_address": "5827 S Dale Mabry Hwy, Tampa, FL 33611, USA",
      "poi_short_description": "A picture menu of classic Chinese take-out dishes in a no frills setting with limited seating.",
      "poi_long_description": "A picture menu of classic Chinese take-out dishes in a no frills setting with limited seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-f9b8-75be-a518-750df6110c1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-f9b8-75be-a518-750df6110c1e",
        "storage_key": "property/6767906449167733/01a03a31-f9b8-75be-a518-750df6110c1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fronteats.com/product/?mid=853506#/pos/home/home?mid=853506",
      "poi_directions_map_url": "https://maps.google.com/?cid=11064163989678324499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-of-china",
      "poi_latitude": "27.8822911",
      "poi_longitude": "-82.507125",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-805-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY--wZujcwogRE_txNYfOi5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_aa4a5c94be6fe12f1ab404f9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "MAMAS KITCHEN",
      "poi_type": "Restaurants",
      "poi_address": "5524 S Dale Mabry Hwy, Tampa, FL 33611, USA",
      "poi_short_description": "Modest diner offering breakfast-to-dinner eats such as waffles, sandwiches & fried chicken.",
      "poi_long_description": "Modest diner offering breakfast-to-dinner eats such as waffles, sandwiches & fried chicken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-fa33-712f-8862-f90544a57f44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-fa33-712f-8862-f90544a57f44",
        "storage_key": "property/6767906449167733/01a03a31-fa33-712f-8862-f90544a57f44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mamaskitchensouthtampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3419531994329100948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mamas-kitchen",
      "poi_latitude": "27.8848344",
      "poi_longitude": "-82.50615189999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-831-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4gYJOjcwogRlLIRPDuedC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "ec_4a27789762d78a2c5807313b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Luigi's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3671 S Westshore Blvd, Tampa, FL 33629, USA",
      "poi_short_description": "Specials like slow-cooked risotto, homemade gnocchi and fresh seafood in casual Italian atmosphere.",
      "poi_long_description": "Specials like slow-cooked risotto, homemade gnocchi and fresh seafood in casual Italian atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a31-fdb7-73db-bc92-ec35376da9bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a31-fdb7-73db-bc92-ec35376da9bc",
        "storage_key": "property/6767906449167733/01a03a31-fdb7-73db-bc92-ec35376da9bc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://luigiskitchentampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7513565261595081471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luigis-kitchen",
      "poi_latitude": "27.909735",
      "poi_longitude": "-82.527011",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-831-9572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWgqAtbcwogR__oW_suLRWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_1d8b97fe3b6d3df56703a6f5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Water + Flour",
      "poi_type": "Restaurants",
      "poi_address": "1015 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "California fare & creative sushi rolls are the draw at this upbeat eatery with regular live music.",
      "poi_long_description": "California fare & creative sushi rolls are the draw at this upbeat eatery with regular live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0161-771a-a8d8-7fabe6d7ab2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0161-771a-a8d8-7fabe6d7ab2b",
        "storage_key": "property/6767906449167733/01a03a32-0161-771a-a8d8-7fabe6d7ab2b.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.waterandfloursoho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10126717247320533471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "water--flour",
      "poi_latitude": "27.9330634",
      "poi_longitude": "-82.48341359999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 813-251-8406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QC_BmfDwogR36lcy65TiYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_12a59ae5b1fc64d2f25e14dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Publix Super Market at Gandy Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3617 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Grocery store with a deli, florist, and seafood market, plus organic produce, and prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-03fa-775d-b4b9-37eca24c309e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-03fa-775d-b4b9-37eca24c309e",
        "storage_key": "property/6767906449167733/01a03a32-03fa-775d-b4b9-37eca24c309e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=2574340091416463092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-gandy-shopping-center",
      "poi_latitude": "27.8948936",
      "poi_longitude": "-82.5030975",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-832-1779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-3001-73ed-9612-6a8930dbcac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-3001-73ed-9612-6a8930dbcac2",
        "storage_key": "property/6767906449167733/01a03a2f-3001-73ed-9612-6a8930dbcac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2ogxcXcwogR9Mbsd6zkuSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_bcd61d56e8bbc35ccb3077bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3625 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1d4f-75b8-a860-da204cbb643f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1d4f-75b8-a860-da204cbb643f",
        "storage_key": "property/6767906449167733/01a03a32-1d4f-75b8-a860-da204cbb643f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/gandy/1051",
      "poi_directions_map_url": "https://maps.google.com/?cid=9161589724553856102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "27.8950682",
      "poi_longitude": "-82.5050741",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-835-8333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa7-73fc-8474-3daeffab36ec",
        "storage_key": "property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGc0ZCMXcwogRZsTmdVCBJH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_a089cec5419c5296acb31de7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3102 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-00f5-7311-bc20-6eabced5ff09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-00f5-7311-bc20-6eabced5ff09",
        "storage_key": "property/6767906449167733/01a03a32-00f5-7311-bc20-6eabced5ff09.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tampa-fl-pharmacies/3102-w-gandy-blvd-tampa-fl-33611/storeid=2802?WT.mc_id=LS_GOOGLE_RX_2802",
      "poi_directions_map_url": "https://maps.google.com/?cid=9368884338311908636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.8932041",
      "poi_longitude": "-82.49432940000001",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-902-1833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4255-75f5-944e-44ddc635d3bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4255-75f5-944e-44ddc635d3bb",
        "storage_key": "property/6767906449167733/01a03a32-4255-75f5-944e-44ddc635d3bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwnH_7jcwogRHE3Nzqr2BII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d29bd62f40787f6ddd59d2bf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4738 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-01e5-7228-bbef-6943a9b2e212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-01e5-7228-bbef-6943a9b2e212",
        "storage_key": "property/6767906449167733/01a03a32-01e5-7228-bbef-6943a9b2e212.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4738+w+gandy+blvd-tampa-fl-33611/id=3744",
      "poi_directions_map_url": "https://maps.google.com/?cid=11715053607491598769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "27.8928506",
      "poi_longitude": "-82.5262971",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-837-1848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4PUZCTdwogRsfkx3y87lKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_57b59fe6f7d686a15b779d6b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4302 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Chain department store supplying groceries, electronics, clothing, home goods, and other merchandise.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0311-7249-8560-60815ad0c035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0311-7249-8560-60815ad0c035",
        "storage_key": "property/6767906449167733/01a03a32-0311-7249-8560-60815ad0c035.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4681-tampa-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14436248459760995668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "27.8915004",
      "poi_longitude": "-82.5163345",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-371-9444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa7-73fc-8474-3daeffab36ec",
        "storage_key": "property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS-Nc0djcwogRVI1V1XzbV8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_e3e18b25737e4fa629719c93",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3101 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0398-74bb-a20b-3a64c302726c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0398-74bb-a20b-3a64c302726c",
        "storage_key": "property/6767906449167733/01a03a32-0398-74bb-a20b-3a64c302726c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/tampa/3101-w.-gandy-blvd.-22724?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7142873781701329262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "27.8941356",
      "poi_longitude": "-82.4940931",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-538-0725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4226-7213-bb8f-91079f59fba3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4226-7213-bb8f-91079f59fba3",
        "storage_key": "property/6767906449167733/01a03a32-4226-7213-bb8f-91079f59fba3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ11DfrbncwogRbkHCIdyVIGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_33bac93390da9a8726281cc3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Manhattan Citgo",
      "poi_type": "Transportation & Transit",
      "poi_address": "4532 S Manhattan Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Gas station with a restroom supplying diesel and gas, as well as cigarettes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-057e-724b-a77b-0b22aaa06875.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-057e-724b-a77b-0b22aaa06875",
        "storage_key": "property/6767906449167733/01a03a32-057e-724b-a77b-0b22aaa06875.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14300205293573580936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manhattan-citgo",
      "poi_latitude": "27.8979488",
      "poi_longitude": "-82.5181684",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-832-5519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4230-739c-8be2-d014361f6e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4230-739c-8be2-d014361f6e73",
        "storage_key": "property/6767906449167733/01a03a32-4230-739c-8be2-d014361f6e73.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ784Q-tfcwogRiCid4vKIdMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_9659be66a706d3e024336431",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Publix Super Market at Britton Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "3838 Britton Plaza, Tampa, FL 33611, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-057f-76df-9a48-1fafe17cd3ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-057f-76df-9a48-1fafe17cd3ab",
        "storage_key": "property/6767906449167733/01a03a32-057f-76df-9a48-1fafe17cd3ab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1506&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=2148485257510705503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-britton-plaza",
      "poi_latitude": "27.9071289",
      "poi_longitude": "-82.502558",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-835-1280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-3001-73ed-9612-6a8930dbcac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-3001-73ed-9612-6a8930dbcac2",
        "storage_key": "property/6767906449167733/01a03a2f-3001-73ed-9612-6a8930dbcac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01zXxczcwogRX9kWY_Xz0B0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_a60de5f3b4ea54c41f5d93a1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Kenneth E. Adum K-8 Magnet School",
      "poi_type": "Education",
      "poi_address": "4210 W Bay Villa Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0445-77bd-82f6-13d47d5e018e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0445-77bd-82f6-13d47d5e018e",
        "storage_key": "property/6767906449167733/01a03a32-0445-77bd-82f6-13d47d5e018e.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.hillsboroughschools.org/adum",
      "poi_directions_map_url": "https://maps.google.com/?cid=3116210887115108888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenneth-e-adum-k-8-magnet-school",
      "poi_latitude": "27.9074615",
      "poi_longitude": "-82.5152238",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-450-1703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeb-72dLcwogRGHKzm0oBPys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0bd80496b2a951254eceddef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Anderson Elementary School",
      "poi_type": "Education",
      "poi_address": "3910 W Fair Oaks Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hillsboroughschools.org/anderson",
      "poi_directions_map_url": "https://maps.google.com/?cid=2884055279979733095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anderson-elementary-school",
      "poi_latitude": "27.900255",
      "poi_longitude": "-82.5092696",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-272-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt0X0RtDcwogRZyDIK_84Big",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e83b3abd7e4bf9a9c89f649f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Ballast Point Elementary School",
      "poi_type": "Education",
      "poi_address": "2802 W Ballast Point Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-09bb-751d-b795-69dcf785069f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-09bb-751d-b795-69dcf785069f",
        "storage_key": "property/6767906449167733/01a03a32-09bb-751d-b795-69dcf785069f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ballastpoint.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4404004911785751104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballast-point-elementary-school",
      "poi_latitude": "27.8893154",
      "poi_longitude": "-82.4879169",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-272-3070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYVjIfrzcwogRQLIQRCIrHj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5bc788fd1d0248c38c8721ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Chiaramonte Elementary School",
      "poi_type": "Education",
      "poi_address": "6001 S Himes Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://chiaramonte.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16049641415282202733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chiaramonte-elementary-school",
      "poi_latitude": "27.8827256",
      "poi_longitude": "-82.50311889999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-272-3066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHxp_m-ncwogRbRhLItXHu94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c04b62434c1b328e617b7f95",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Madison Middle School",
      "poi_type": "Education",
      "poi_address": "4444 W Bay Vista Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-08f1-72c4-8e01-887604cadd21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-08f1-72c4-8e01-887604cadd21",
        "storage_key": "property/6767906449167733/01a03a32-08f1-72c4-8e01-887604cadd21.webp",
        "width": 721,
        "height": 526
      },
      "poi_business_url": "http://madison.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2596374590663861458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-middle-school",
      "poi_latitude": "27.9066807",
      "poi_longitude": "-82.5207016",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-272-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg-Cr8yrdwogR0qReHO8sCCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_578597402ee78c0dc58c41d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Bayshore Christian School",
      "poi_type": "Education",
      "poi_address": "3909 S MacDill Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0e76-73d8-8311-3285ceca43d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0e76-73d8-8311-3285ceca43d2",
        "storage_key": "property/6767906449167733/01a03a32-0e76-73d8-8311-3285ceca43d2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.bayshorechristianschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581565827202229356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayshore-christian-school",
      "poi_latitude": "27.9068706",
      "poi_longitude": "-82.49404059999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-839-4297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbUqUgJPcwogRbCTZJIy0dU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_2f2235dc3b0675f9bebf1940",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Children's Discovery",
      "poi_type": "Education",
      "poi_address": "13101 N 23rd St, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0ad7-74ce-ae81-3b73f16cd629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0ad7-74ce-ae81-3b73f16cd629",
        "storage_key": "property/6767906449167733/01a03a32-0ad7-74ce-ae81-3b73f16cd629.webp",
        "width": 960,
        "height": 856
      },
      "poi_business_url": "http://atchildrensdiscovery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7679309591108560632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-discovery",
      "poi_latitude": "28.065783",
      "poi_longitude": "-82.432126",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "6 hours 27 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 813-977-6266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXY3-ngrHwogR-KZG6mJjkmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_f2e6928fbc39e0ef13bdec1d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Little Saints Academy",
      "poi_type": "Education",
      "poi_address": "4300 S Manhattan Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.littlesaintsacademytpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1805921293944768059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-saints-academy",
      "poi_latitude": "27.9025298",
      "poi_longitude": "-82.5178803",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-921-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5YgEqRjdwogRO0bkQdnrDxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_21f7b2e3b2f2f1c198f8d6ca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "The Goddard School of Interbay",
      "poi_type": "Education",
      "poi_address": "6204 Interbay Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0e2c-77f9-9cd7-c2b407ecb506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0e2c-77f9-9cd7-c2b407ecb506",
        "storage_key": "property/6767906449167733/01a03a32-0e2c-77f9-9cd7-c2b407ecb506.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goddardschool.com/schools/fl/tampa/interbay?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=13778096126167395383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-interbay",
      "poi_latitude": "27.8784981",
      "poi_longitude": "-82.49620399999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-582-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdYYnlpHdwogRN6xkYW2hNb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_463b6d69e2d4330094711586",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Top Kids Bilingual Preschool , MacDill Campus",
      "poi_type": "Education",
      "poi_address": "6807 S MacDill Ave, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0f8c-7539-a9b0-d2a7d215af14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0f8c-7539-a9b0-d2a7d215af14",
        "storage_key": "property/6767906449167733/01a03a32-0f8c-7539-a9b0-d2a7d215af14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.topkidspreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11631141409331798880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "top-kids-bilingual-preschool--macdill-campus",
      "poi_latitude": "27.8685777",
      "poi_longitude": "-82.49445829999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-374-3037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnfGQiDzdwogRYOOOw3wdaqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_35a4933d418a768aacb0820c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Armature Works",
      "poi_type": "Restaurants",
      "poi_address": "1910 N Ola Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_long_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-11e4-71d7-93da-f46958bc337b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-11e4-71d7-93da-f46958bc337b",
        "storage_key": "property/6767906449167733/01a03a32-11e4-71d7-93da-f46958bc337b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://armatureworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15923683446625658433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armature-works",
      "poi_latitude": "27.9609343",
      "poi_longitude": "-82.4642724",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 813-250-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-b0bab736dde5",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-b0bab736dde5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWj9iZ_PwogRQebjN7pJ_Nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d0cd9483abd26c0d6f70cfa1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Sparkman Wharf",
      "poi_type": "Entertainment",
      "poi_address": "615 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_long_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0e14-748b-994a-efaede66c049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0e14-748b-994a-efaede66c049",
        "storage_key": "property/6767906449167733/01a03a32-0e14-748b-994a-efaede66c049.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sparkmanwharf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298001502316238008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sparkman-wharf",
      "poi_latitude": "27.9433292",
      "poi_longitude": "-82.4476555",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-618-5844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0N73GTFwogRuJTf5jAk5B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "ec_46952e7d4af147cdf2dfe45a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "The Florida Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "701 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_long_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-0e0c-74b8-b06a-a8965ba6f8a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-0e0c-74b8-b06a-a8965ba6f8a6",
        "storage_key": "property/6767906449167733/01a03a32-0e0c-74b8-b06a-a8965ba6f8a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088866459868476301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-florida-aquarium",
      "poi_latitude": "27.943972",
      "poi_longitude": "-82.44487470000001",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4230-739c-8be2-d676c9c1be78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4230-739c-8be2-d676c9c1be78",
        "storage_key": "property/6767906449167733/01a03a32-4230-739c-8be2-d676c9c1be78.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJCXAq5_DEwogRjTPE2xlsZtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_f361db313ae23eeb01c08493",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Glazer Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "110 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_long_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1bbe-73c9-bc6c-45b3f07b5e4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1bbe-73c9-bc6c-45b3f07b5e4e",
        "storage_key": "property/6767906449167733/01a03a32-1bbe-73c9-bc6c-45b3f07b5e4e.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.glazermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14656511005827888982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glazer-childrens-museum",
      "poi_latitude": "27.949577",
      "poi_longitude": "-82.461494",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-443-3861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd4-7584-a6fe-911f6543ffa2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd4-7584-a6fe-911f6543ffa2",
        "storage_key": "property/6767906449167733/01a03a2f-2fd4-7584-a6fe-911f6543ffa2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6lKAInEwogRVnf5NBtjZss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_936ad6055188ec5ef84c11ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Tampa Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "120 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_long_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1217-719a-92b1-05d46e5c02db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1217-719a-92b1-05d46e5c02db",
        "storage_key": "property/6767906449167733/01a03a32-1217-719a-92b1-05d46e5c02db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14070563233475260026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-museum-of-art",
      "poi_latitude": "27.9494852",
      "poi_longitude": "-82.4629535",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-274-8130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd4-7584-a6fe-911f6543ffa2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd4-7584-a6fe-911f6543ffa2",
        "storage_key": "property/6767906449167733/01a03a2f-2fd4-7584-a6fe-911f6543ffa2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6ESWITDwogReu72OLauRMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_e94fa95006c252c346029610",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Tampa Theatre",
      "poi_type": "Entertainment",
      "poi_address": "711 N Franklin St, Tampa, FL 33602, USA",
      "poi_short_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_long_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1610-7394-8c33-40d33f21c9f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1610-7394-8c33-40d33f21c9f3",
        "storage_key": "property/6767906449167733/01a03a32-1610-7394-8c33-40d33f21c9f3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tampatheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13247868558926946431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-theatre",
      "poi_latitude": "27.9503523",
      "poi_longitude": "-82.4589293",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-274-8286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-422f-7129-b009-96b4e36a93d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-422f-7129-b009-96b4e36a93d0",
        "storage_key": "property/6767906449167733/01a03a32-422f-7129-b009-96b4e36a93d0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98cKiInEwogRfyDonUPi2bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0d764d13aa4cdd5d2754e0c0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Straz Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1010 N WC Macinnes Pl, Tampa, FL 33602, USA",
      "poi_short_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_long_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-18f6-7053-a741-2aaf2c39d514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-18f6-7053-a741-2aaf2c39d514",
        "storage_key": "property/6767906449167733/01a03a32-18f6-7053-a741-2aaf2c39d514.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.strazcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331971547108004456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "straz-center-for-the-performing-arts",
      "poi_latitude": "27.9516604",
      "poi_longitude": "-82.4640622",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-229-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJce6XFIjEwogRaNJA6ZKu31c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_7d5739a9f0158a89fd7e78fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Busch Gardens Tampa Bay",
      "poi_type": "Entertainment",
      "poi_address": "10165 McKinley Dr, Tampa, FL 33612, USA",
      "poi_short_description": "Venerable theme park with thrill rides, African animals, live entertainment & kiddie attractions.",
      "poi_long_description": "Venerable theme park with thrill rides, African animals, live entertainment & kiddie attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1902-7080-b9dd-80d1d678e952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1902-7080-b9dd-80d1d678e952",
        "storage_key": "property/6767906449167733/01a03a32-1902-7080-b9dd-80d1d678e952.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://buschgardens.com/tampa?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152398480662399058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "busch-gardens-tampa-bay",
      "poi_latitude": "28.037066",
      "poi_longitude": "-82.4194607",
      "poi_miles_from_property": "16.3 mi",
      "poi_walking_minutes": "6 hours 6 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 813-884-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRo4DU_GwogRUgjhMAj-pag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_cbc0ac8a1965fd52651e011b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "ZooTampa at Lowry Park",
      "poi_type": "Entertainment",
      "poi_address": "1101 W Sligh Ave, Tampa, FL 33604, USA",
      "poi_short_description": "Celebrated zoo offering giraffe feeding, educational programs & a water play area.",
      "poi_long_description": "Celebrated zoo offering giraffe feeding, educational programs & a water play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-15be-74d5-bad8-739cdef6c3ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-15be-74d5-bad8-739cdef6c3ec",
        "storage_key": "property/6767906449167733/01a03a32-15be-74d5-bad8-739cdef6c3ec.webp",
        "width": 700,
        "height": 465
      },
      "poi_business_url": "https://zootampa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15196843952485795119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zootampa-at-lowry-park",
      "poi_latitude": "28.0138361",
      "poi_longitude": "-82.4699672",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 813-935-8552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQ5SjLHGwogRL4X19g4J5tI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_0b12da5900dd964ff3d9e103",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "HCA Florida South Tampa Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 W Swann Ave, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-1a90-76eb-99ef-e1b009e945dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-1a90-76eb-99ef-e1b009e945dc",
        "storage_key": "property/6767906449167733/01a03a2f-1a90-76eb-99ef-e1b009e945dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/south-tampa-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13028462800937743450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-south-tampa-hospital",
      "poi_latitude": "27.937941",
      "poi_longitude": "-82.4893956",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-873-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd8-763c-a79b-279118034aab",
        "storage_key": "property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYKXwW7DwogRWvRIw-NlzrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1750434f62b057b176de22a8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "TGH Urgent Care powered by Fast Track (South Tampa)",
      "poi_type": "Health and Wellness",
      "poi_address": "3301 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1892-7004-a4ea-66cfc121e0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1892-7004-a4ea-66cfc121e0f2",
        "storage_key": "property/6767906449167733/01a03a32-1892-7004-a4ea-66cfc121e0f2.webp",
        "width": 907,
        "height": 510
      },
      "poi_business_url": "https://www.fasttrackurgentcare.com/locations-and-hours/south-tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=833633215494276421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgh-urgent-care-powered-by-fast-track-south-tampa",
      "poi_latitude": "27.893977",
      "poi_longitude": "-82.49869199999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-925-1903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmc8QiaHdwogRRcWAIv6okQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_054d6b073bd255fd615892b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Gandy Shopping Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3617 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1af0-71ad-beb6-b04db63a626e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1af0-71ad-beb6-b04db63a626e",
        "storage_key": "property/6767906449167733/01a03a32-1af0-71ad-beb6-b04db63a626e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996281934555058736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-gandy-shopping-center",
      "poi_latitude": "27.8950208",
      "poi_longitude": "-82.5031836",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-337-5269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4255-75f5-944e-44ddc635d3bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4255-75f5-944e-44ddc635d3bb",
        "storage_key": "property/6767906449167733/01a03a32-4255-75f5-944e-44ddc635d3bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2ogxcXcwogRMBKvvNc3tBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_221d8320074375b7267c18ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Crunch Fitness - South Tampa",
      "poi_type": "Health and Wellness",
      "poi_address": "4055 S Dale Mabry Hwy, Tampa, FL 33611, USA",
      "poi_short_description": "Relaxed gym featuring personal trainers, weight machines and group classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-1587-777d-a134-6de784c6dad6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-1587-777d-a134-6de784c6dad6",
        "storage_key": "property/6767906449167733/01a03a2f-1587-777d-a134-6de784c6dad6.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/south-tampa",
      "poi_directions_map_url": "https://maps.google.com/?cid=18136045507165587425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---south-tampa",
      "poi_latitude": "27.9050044",
      "poi_longitude": "-82.5073355",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-284-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyVThM3cwogR4YfsxEwtsPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7d7db39179d696a266c58591",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Rock it Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5242 Bridge St, Tampa, FL 33611, USA",
      "poi_short_description": "Upbeat space for workouts, offering indoor cycling on Stages bikes, Pilates and yoga sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1ae5-73bf-8eb6-a70c3b7b3f7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1ae5-73bf-8eb6-a70c3b7b3f7b",
        "storage_key": "property/6767906449167733/01a03a32-1ae5-73bf-8eb6-a70c3b7b3f7b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://rockitfitness.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4606525715056805673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-it-fitness",
      "poi_latitude": "27.8895634",
      "poi_longitude": "-82.52950980000001",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 716-828-5177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0j91DzdwogRKcepPruq7T8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f25f5cbe8c685223eefad205",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Cocoon: Yoga & Movement Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "4105 S MacDill Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Yoga and movement studio featuring classes in a warm, welcoming environment amid simple decor.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1c3c-72fd-bc57-9af4c2d14e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1c3c-72fd-bc57-9af4c2d14e6a",
        "storage_key": "property/6767906449167733/01a03a32-1c3c-72fd-bc57-9af4c2d14e6a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cocoontampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091086098092802138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cocoon-yoga--movement-studio",
      "poi_latitude": "27.9050015",
      "poi_longitude": "-82.494092",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-738-5604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3esKP1_dwogRWkBQu6MGKn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_262a8e3830aedd2fc9b2974c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Bayshore Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "4219 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Gym featuring cardio and weight-training machines as well as friendly personal trainers and fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-1edb-7759-ad7d-e8c9089c989f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-1edb-7759-ad7d-e8c9089c989f",
        "storage_key": "property/6767906449167733/01a03a32-1edb-7759-ad7d-e8c9089c989f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://bayshorefit.com/?utm_source=GMB_listing&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068891181943526352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayshore-fit",
      "poi_latitude": "27.8947088",
      "poi_longitude": "-82.5153859",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-609-2939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzd1s4kXDwogR0JMSMkXklio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0d6bbc8fbf9044e504d99e65",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Pilates By Dena",
      "poi_type": "Health and Wellness",
      "poi_address": "3113 S Dale Mabry Hwy, Tampa, FL 33629, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2332-761d-91cf-4336de99752a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2332-761d-91cf-4336de99752a",
        "storage_key": "property/6767906449167733/01a03a32-2332-761d-91cf-4336de99752a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pilatesbydena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8467007529542332320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-by-dena",
      "poi_latitude": "27.9178883",
      "poi_longitude": "-82.5061856",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-831-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW5NIvNjcwogRoK_t7HzagHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_cd0d97b2bc9d2be0ee007972",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "AJ Palonis Jr Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5151 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Small park on Tampa Bay featuring boardwalk trails through mangrove forests, plus sunset views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-20da-77e9-ac07-7a9b3e9b7292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-20da-77e9-ac07-7a9b3e9b7292",
        "storage_key": "property/6767906449167733/01a03a32-20da-77e9-ac07-7a9b3e9b7292.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tampa.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9232353887126419961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aj-palonis-jr-park",
      "poi_latitude": "27.8916092",
      "poi_longitude": "-82.54094119999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRKbXQ3dwogR-fnd-vHoH4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_62e7d12496d709ba4a269c10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Gandy Park South",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5121 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-22b0-752d-84b9-ad7ccc5bca35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-22b0-752d-84b9-ad7ccc5bca35",
        "storage_key": "property/6767906449167733/01a03a32-22b0-752d-84b9-ad7ccc5bca35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594141077260120078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gandy-park-south",
      "poi_latitude": "27.8916464",
      "poi_longitude": "-82.5368575",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-832-1243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdCoOD_dwogRDrC6ZkT04DE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0356e9713d3d94b855e5eba1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Gandy Boat Ramp",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5108 W Gandy Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-216c-726b-8c73-7bec0b41f7bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-216c-726b-8c73-7bec0b41f7bd",
        "storage_key": "property/6767906449167733/01a03a32-216c-726b-8c73-7bec0b41f7bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/gandy-boat-ramp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2746481147447309155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gandy-boat-ramp",
      "poi_latitude": "27.8923571",
      "poi_longitude": "-82.5330074",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6MQdjzdwogRY3PnVw12HSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e033d6e77e1a53ad31c9569f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Palma Ceia Lions Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4525 W Pearl Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Family-friendly rec space with a playground, a ball field and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-22b7-7736-8503-7153417bcb1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-22b7-7736-8503-7153417bcb1b",
        "storage_key": "property/6767906449167733/01a03a32-22b7-7736-8503-7153417bcb1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation/parks-and-facilities/playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615238103140790147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palma-ceia-lions-park",
      "poi_latitude": "27.8877416",
      "poi_longitude": "-82.521259",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-832-1243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8gpSyDdwogRg-89BAYvleY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_903a6153ce1618d0051757d5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Ballast Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5300 Interbay Blvd, Tampa, FL 33611, USA",
      "poi_short_description": "Historic waterfront park offering views of Downtown with a cafe, pier, picnicking & a playground.",
      "poi_long_description": "Historic waterfront park offering views of Downtown with a cafe, pier, picnicking & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-1e1d-753b-ad13-a15a8ff2122d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-1e1d-753b-ad13-a15a8ff2122d",
        "storage_key": "property/6767906449167733/01a03a2f-1e1d-753b-ad13-a15a8ff2122d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tampa.gov/parks-and-recreation/featured-parks/ballast-point",
      "poi_directions_map_url": "https://maps.google.com/?cid=4681954868787410028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballast-point-park",
      "poi_latitude": "27.8889874",
      "poi_longitude": "-82.4812381",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZgnUKHcwogRbPR7qCWl-UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_1925b02077908904c87cec29",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Cortland Bowery",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6301 S Westshore Blvd, Tampa, FL 33616, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2409-710c-ab66-f03d2dfa0709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2409-710c-ab66-f03d2dfa0709",
        "storage_key": "property/6767906449167733/01a03a32-2409-710c-ab66-f03d2dfa0709.webp",
        "width": 1280,
        "height": 763
      },
      "poi_business_url": "https://cortland.com/apartments/cortland-bowery/?utm_source=gmb_site&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9273284050460632504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cortland-bowery",
      "poi_latitude": "27.8770058",
      "poi_longitude": "-82.5285978",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-590-7921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUEoVBrdwogRuGUAQbZSsYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_f61bd26508a166134c050439",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Spanish American War Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4752 W Prescott St, Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2571-73b0-acd1-f357b831f52c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2571-73b0-acd1-f357b831f52c",
        "storage_key": "property/6767906449167733/01a03a32-2571-73b0-acd1-f357b831f52c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12819729379583920688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spanish-american-war-memorial-park",
      "poi_latitude": "27.8670326",
      "poi_longitude": "-82.5265751",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-832-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6pl6wbdwogRMAq96vLT6LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f74d1a9282ef91d5b687c391",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Port Tampa Park Community Center",
      "poi_type": "Entertainment",
      "poi_address": "4702 W McCoy St, Tampa, FL 33616, USA",
      "poi_short_description": "Clean facility with an air-conditioned space for community programs such as ceramics as well as table tennis.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-271f-7153-a031-7495522ae779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-271f-7153-a031-7495522ae779",
        "storage_key": "property/6767906449167733/01a03a32-271f-7153-a031-7495522ae779.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tampa.gov/parks-and-recreation/activities-recreation/recreation-centers",
      "poi_directions_map_url": "https://maps.google.com/?cid=16518370943208773345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-tampa-park-community-center",
      "poi_latitude": "27.8691646",
      "poi_longitude": "-82.52341349999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-832-1215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98FwYAHdwogR4dYX0toKPeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_0b0c92d57c2a5e477bdf9082",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Skyview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6203 S Martindale Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Public green space offering basketball and tennis courts, a playground, and fields for baseball, football, and soccer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-265c-73bc-9b6f-bcc753c5ee8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-265c-73bc-9b6f-bcc753c5ee8d",
        "storage_key": "property/6767906449167733/01a03a32-265c-73bc-9b6f-bcc753c5ee8d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16216522678647232239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyview-park",
      "poi_latitude": "27.876854",
      "poi_longitude": "-82.495575",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2wnFpPcwogR75bVGHWpDOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_672048b748e6589e1027d15c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Gadsden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6901 S MacDill Ave, Tampa, FL 33611, USA",
      "poi_short_description": "Major city park with a lake, sports fields, picnicking, dog area, playground & trails for jogging.",
      "poi_long_description": "Major city park with a lake, sports fields, picnicking, dog area, playground & trails for jogging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-27e7-746f-8446-e61ec6549b5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-27e7-746f-8446-e61ec6549b5f",
        "storage_key": "property/6767906449167733/01a03a32-27e7-746f-8446-e61ec6549b5f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.tampa.gov/parks-and-recreation/programs/parks-and-facilities/greenways-and-trails/trail-maps/macdill-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=4935383957153965182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gadsden-park",
      "poi_latitude": "27.867167",
      "poi_longitude": "-82.49577719999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-274-7733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32a9-71e8-b423-cf65a1a9b7c4",
        "storage_key": "property/6767906449167733/01a03a2f-32a9-71e8-b423-cf65a1a9b7c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzdBRYvcwogRfuRSbI8BfkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bce14191772c300e162ed1f9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "West Tampa Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18132250933078481478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-tampa-transfer-center",
      "poi_latitude": "27.97771",
      "poi_longitude": "-82.50097",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-423c-7347-a587-dd06af036f3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-423c-7347-a587-dd06af036f3e",
        "storage_key": "property/6767906449167733/01a03a32-423c-7347-a587-dd06af036f3e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00_zXb_DwogRRlpjpCeyovs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_757b4521a273d2908a6894e0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Marion Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1211 N Marion St, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2a34-734b-bce7-4136b38e278b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2a34-734b-bce7-4136b38e278b",
        "storage_key": "property/6767906449167733/01a03a32-2a34-734b-bce7-4136b38e278b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gohart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356063461840094640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-transit-center",
      "poi_latitude": "27.95561",
      "poi_longitude": "-82.45827",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4262-77ba-83f6-a0210927eb7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4262-77ba-83f6-a0210927eb7b",
        "storage_key": "property/6767906449167733/01a03a32-4262-77ba-83f6-a0210927eb7b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X6-i2HEwogRsIUp2UCOeas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_0924a649d04dcaf57f43b41d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Netpark Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4948 N 56th St, Tampa, FL 33619, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2969-745d-babc-32087c313e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2969-745d-babc-32087c313e54",
        "storage_key": "property/6767906449167733/01a03a32-2969-745d-babc-32087c313e54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7756711966683944594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "netpark-transfer-center",
      "poi_latitude": "27.9900104",
      "poi_longitude": "-82.391252",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4268-773f-9a02-c019efcd07eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4268-773f-9a02-c019efcd07eb",
        "storage_key": "property/6767906449167733/01a03a32-4268-773f-9a02-c019efcd07eb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfcfNfnFwogRktY3129gpWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_eda124de91c7989375ebb12d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Northwest Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8951 W Waters Ave, Tampa, FL 33615, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2a91-702d-a7a2-831fbfa9aa50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2a91-702d-a7a2-831fbfa9aa50",
        "storage_key": "property/6767906449167733/01a03a32-2a91-702d-a7a2-831fbfa9aa50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16322407467610345592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transfer-center",
      "poi_latitude": "28.0277315",
      "poi_longitude": "-82.5856912",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4268-773f-9a02-c019efcd07eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4268-773f-9a02-c019efcd07eb",
        "storage_key": "property/6767906449167733/01a03a32-4268-773f-9a02-c019efcd07eb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_5hoj_qwogReBAZqhzXhOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_49fe45bcd7a66388f60ff252",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "WestShore Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "250 Westshore Plaza, Tampa, FL 33609, USA",
      "poi_short_description": "Popular department & chain stores, a multi-screen movie complex plus restaurants & a food court.",
      "poi_long_description": "Popular department & chain stores, a multi-screen movie complex plus restaurants & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-0523-7443-9918-179310266db0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-0523-7443-9918-179310266db0",
        "storage_key": "property/6767906449167733/01a03a2f-0523-7443-9918-179310266db0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://westshoreplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14540089015988473676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westshore-plaza",
      "poi_latitude": "27.9473502",
      "poi_longitude": "-82.5274596",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-286-0790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa7-73fc-8474-3daeffab36ec",
        "storage_key": "property/6767906449167733/01a03a2f-2fa7-73fc-8474-3daeffab36ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqXGhh8rDwogRTE-NYOzFyMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0d717cf5171ef40b7de91a37",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 N Nebraska Ave, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2c34-761d-822f-85bfc50587b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2c34-761d-822f-85bfc50587b3",
        "storage_key": "property/6767906449167733/01a03a32-2c34-761d-822f-85bfc50587b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/tpa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680206783434409790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "27.9526866",
      "poi_longitude": "-82.45065249999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 833-844-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWlYhl_EwogRPke3ZS9uGKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_9ce9fc2e7fa868da52816abd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Tampa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4100 George J. Bean Pkwy, Tampa, FL 33607, USA",
      "poi_short_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_long_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2ce1-717f-83c1-47735f7e0705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2ce1-717f-83c1-47735f7e0705",
        "storage_key": "property/6767906449167733/01a03a32-2ce1-717f-83c1-47735f7e0705.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816785868724491529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-international-airport",
      "poi_latitude": "27.9768646",
      "poi_longitude": "-82.5302804",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 813-870-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32c2-72e8-b2c5-78301f96f89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32c2-72e8-b2c5-78301f96f89a",
        "storage_key": "property/6767906449167733/01a03a2f-32c2-72e8-b2c5-78301f96f89a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0Sek0bCwogRCdUBxgiEW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_3fa860d5b3a93434c47d31bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Dick Greco Plaza Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2f52-71af-b2c5-94a16bc50dff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2f52-71af-b2c5-94a16bc50dff",
        "storage_key": "property/6767906449167733/01a03a32-2f52-71af-b2c5-94a16bc50dff.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364926643300246030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dick-greco-plaza-station",
      "poi_latitude": "27.9415784",
      "poi_longitude": "-82.45481269999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-32f4-74de-861c-b3c66ad5ebfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-32f4-74de-861c-b3c66ad5ebfc",
        "storage_key": "property/6767906449167733/01a03a2f-32f4-74de-861c-b3c66ad5ebfc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVftQo3EwogRDqLwg1sMdEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_fad86060bee45c766d896733",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Coast Bike Share",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Franklin St, Tampa, FL 33646, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-2c80-765f-8c1f-ab8e9cd5a2ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-2c80-765f-8c1f-ab8e9cd5a2ab",
        "storage_key": "property/6767906449167733/01a03a32-2c80-765f-8c1f-ab8e9cd5a2ab.webp",
        "width": 1100,
        "height": 619
      },
      "poi_business_url": "http://www.coastbikeshare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2877636464144169980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coast-bike-share",
      "poi_latitude": "27.9516753",
      "poi_longitude": "-82.4608028",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-999-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fba-759e-a55f-1709b41ab931",
        "storage_key": "property/6767906449167733/01a03a2f-2fba-759e-a55f-1709b41ab931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTtli4nEwogR_DsGJh5r7yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bike_sharing_station"
    },
    {
      "id": "ec_9eeb2fa7e6790064c996d393",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "USSOCOM",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7701 Tampa Point Blvd, Tampa, FL 33621, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-301d-773e-a8d2-9c5cd8f66e96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-301d-773e-a8d2-9c5cd8f66e96",
        "storage_key": "property/6767906449167733/01a03a32-301d-773e-a8d2-9c5cd8f66e96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.socom.mil/contact",
      "poi_directions_map_url": "https://maps.google.com/?cid=1967405442618142666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ussocom",
      "poi_latitude": "27.85476",
      "poi_longitude": "-82.48706299999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 813-826-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4268-773f-9a02-c52924635571",
        "storage_key": "property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2bHpmTcwogRyq9siNOgTRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_86382525b47576432c841cb9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Tampa General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Tampa General Cir, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-1a80-756b-899e-844a62d48959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a2f-1a80-756b-899e-844a62d48959",
        "storage_key": "property/6767906449167733/01a03a2f-1a80-756b-899e-844a62d48959.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tgh.org/?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13864056167954562457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-general-hospital",
      "poi_latitude": "27.9377069",
      "poi_longitude": "-82.45921299999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-844-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd8-763c-a79b-279118034aab",
        "storage_key": "property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW92V1ZPEwogRmb3-PKEFZ8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_2e4c8ce6907e6566976d6348",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "St. Joseph's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 W Dr Martin Luther King Jr Blvd, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-3978-701b-835e-562c7e7dbe34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-3978-701b-835e-562c7e7dbe34",
        "storage_key": "property/6767906449167733/01a03a32-3978-701b-835e-562c7e7dbe34.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://baycare.org/locations/hospitals/st-josephs-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=St._Josephs_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=6577266930117397633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital",
      "poi_latitude": "27.9826011",
      "poi_longitude": "-82.4912561",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 813-870-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd8-763c-a79b-279118034aab",
        "storage_key": "property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRhzBuzDwogRgUyS0mwlR1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_92bf59de1e2a6369ae5f54aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Moffitt USF Magnolia Campus- 12902 USF Magnolia drive Tampa, Fl Gold Valet",
      "poi_type": "Education",
      "poi_address": "12902 USF Magnolia Drive, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-38e2-74fe-816c-b2545c8919ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-38e2-74fe-816c-b2545c8919ee",
        "storage_key": "property/6767906449167733/01a03a32-38e2-74fe-816c-b2545c8919ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15953255382480495458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moffitt-usf-magnolia-campus--12902-usf-magnolia-drive-tampa-fl-gold-valet",
      "poi_latitude": "28.0650561",
      "poi_longitude": "-82.42173389999999",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 813-745-2081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL7lJ1p3HwogRYqPWEz9ZZd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f25488f2feacac78dcc16a77",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "University of South Florida",
      "poi_type": "Education",
      "poi_address": "4202 E Fowler Ave, Tampa, FL 33620, USA",
      "poi_short_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_long_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-3904-709b-9763-59525646d0a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-3904-709b-9763-59525646d0a7",
        "storage_key": "property/6767906449167733/01a03a32-3904-709b-9763-59525646d0a7.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.usf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12823001712777334890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-florida",
      "poi_latitude": "28.0622334",
      "poi_longitude": "-82.4135057",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 813-974-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fa8-75ae-b873-aa0193377d24",
        "storage_key": "property/6767906449167733/01a03a2f-2fa8-75ae-b873-aa0193377d24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0__Gw77HwogRapBRXB509LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0cc0d53fd37c72535d8c213c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "James A. Haley Veterans' Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "13000 Bruce B Downs Blvd, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-3978-701b-835e-5b7ab14883f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-3978-701b-835e-5b7ab14883f8",
        "storage_key": "property/6767906449167733/01a03a32-3978-701b-835e-5b7ab14883f8.webp",
        "width": 1280,
        "height": 1117
      },
      "poi_business_url": "https://www.va.gov/tampa-health-care/locations/james-a-haley-veterans-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577032833284040040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-a-haley-veterans-hospital",
      "poi_latitude": "28.0644878",
      "poi_longitude": "-82.42916489999999",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 813-972-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a2f-2fd8-763c-a79b-279118034aab",
        "storage_key": "property/6767906449167733/01a03a2f-2fd8-763c-a79b-279118034aab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZIwdaHHwogRaOWVQNCZZU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_42db883a5a6ad8268b911ebd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Port Tampa Bay",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_long_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-39d0-7214-ad4a-1acd9a180d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-39d0-7214-ad4a-1acd9a180d47",
        "storage_key": "property/6767906449167733/01a03a32-39d0-7214-ad4a-1acd9a180d47.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://porttb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8691922585219425657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-tampa-bay",
      "poi_latitude": "27.9503837",
      "poi_longitude": "-82.4450219",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-905-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4268-773f-9a02-c52924635571",
        "storage_key": "property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8JZy_fEwogReeUyG4rpn3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_29828e96af328473b730c415",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "poi_name": "Hillsborough County Tax Collector",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-3c9b-71d1-a7cb-fc42b6e96228.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a32-3c9b-71d1-a7cb-fc42b6e96228",
        "storage_key": "property/6767906449167733/01a03a32-3c9b-71d1-a7cb-fc42b6e96228.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillstaxfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2993346978512072366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-county-tax-collector",
      "poi_latitude": "27.948334",
      "poi_longitude": "-82.45476599999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-635-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a32-4268-773f-9a02-c52924635571",
        "storage_key": "property/6767906449167733/01a03a32-4268-773f-9a02-c52924635571.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbrlKovEwogRrm6zrzeBiik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d606ae1ad534528351de0ba6",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_093a501126281f457bb84ff7",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_94d928e6c2f753a407f59a89",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e99f8eed316b37ae35cc3ea5",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_433cf32aca1ec7de2f78e128",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7294e802de372ecef7e1e5f3",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5fb0ef66d9f1d66363191918",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6402f2e04f355ea4744f0c5d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "rating": "5",
      "name": "Mimi Mcilroy",
      "text": "Moved in April of 2026, so after 3 months I can say this is a great place to live. It's not perfect, as I am on the 5th floor and have upstairs neighbors that I think live in roller skates and jump rope from time to time, but the views of the water are breathtaking, the amenities are great, the staff is the best I've come across and any question or issue I have is handled promptly.  It’s a gated community and I feel like I live in my own bubble out here.  Salt shake is a great outdoor restaurant right on the water that is right next door and super convenient stores are within a few miles.  I have an 18 month lease and my only wish is I got her sooner to get a closer water front spot!",
      "date": "2026-06-25",
      "title": "false"
    },
    {
      "id": "ec_5bce11235663b9c136f6b419",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "rating": "5",
      "name": "Marissa Velazquez",
      "text": "My boyfriend and I just moved to Breakwater a week ago and let me tell you we had the best experience moving into our new apartment. Shane was so amazing during the whole process! I was going through a crisis in my last apartment, I was super stressed out and Shane made sure the move in process went super smooth. Communication was perfect! If he was not in office someone else was able to pick up where he left off with no gaps of communication. Everyone is super nice, the amenities are perfect, the views never get old! I never would have thought I would live in Breakwater and I’m thankful I found this place! I’m glad to call MAA Breakwater our new home.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "ec_2e45eeea08d490ac2fd0bb77",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "rating": "5",
      "name": "Sophia Tamron",
      "text": "Adriana gave us such a wonderful tour! She was welcoming, knowledgeable, and took the time to answer all of our questions without making us feel rushed. The property itself is absolutely beautiful and truly feels like a resort — from the well-maintained grounds to the impressive amenities. Adriana made the entire experience enjoyable and stress-free, and you can tell she genuinely cares about what she does. We left feeling excited and confident about this community for our daughter. Highly recommend asking for Adriana if you’re touring!",
      "date": "2025-12-28",
      "title": "false"
    },
    {
      "id": "ec_f5e28833376aadd0c5a6ca39",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "rating": "5",
      "name": "Brady H",
      "text": "This is one of our favorite complexes we've ever lived in. Great gym, beautiful walking area next to the water, the maintenance team is great, the front office is helpful, apartment itself is nice, amenity areas are nice, and residents here are friendly. One of the best parts about living here are the events. Robbie and Karysa host events for residents twice per month and they are so fun! The events really bring this place to life.\n\nThe cons of living here are fairly minor. Yes, we can hear our neighbors and the people in the hallway. We got lucky and our neighbors are fairly quiet but we know people with sound complaints. The build workmanship and layouts of the apartments could have been a tiny better.\n\nOverall, very happy to call this place our home and I feel like we are getting a good value for what it is. 5 stars!",
      "date": "2026-08-07",
      "title": "false"
    },
    {
      "id": "ec_491acd081e0dc99d0c3658ad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "rating": "5",
      "name": "Mark Johnson",
      "text": "Can’t say enough how happy I am with my move to MAA Breakwater!!  From the first day I toured MAA Breakwater to my move in day, the entire staff in the leasing office and maintenance department have been awesome. They truly do care about making your experience amazing and are always willing to help you out any way they can!!\n\nI would definitely recommend anyone looking at living at MAA Breakwater to sign a lease!!!",
      "date": "2025-10-10",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-tampa-fl-oasis",
      "search_query": "dog-friendly apartments Tampa FL",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Tampa, FL",
      "h2_subtitle": "Searching for dog-friendly apartments in Tampa, FL? Discover the perfect home at Oasis, where pets are always welcome.",
      "page_copy": "Looking for dog-friendly apartments in Tampa, FL? Oasis, located in the vibrant Sun Bay South neighborhood, is the perfect haven for you and your furry friends. Our community is thoughtfully designed with two spacious dog parks where your pets can run free and socialize in a safe environment. \n\nAt Oasis, you and your four-legged companions will enjoy the benefits of a pet-centric lifestyle, just a stone's throw away from a local park ideal for leisurely walks. Situated in Hillsborough County, Oasis provides not only stunning living spaces but also ensures all residents, including pets, feel right at home. Join our pet-friendly community and relish the perks of living in a welcoming environment for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Tampa, FL",
      "seo_description": "Find dog-friendly apartments in Tampa, FL, at Oasis, featuring two dog parks, a local park, and welcoming homes for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-with-swimming-pool-sun-bay-south-oasis",
      "search_query": "apartments with swimming pool Sun Bay South",
      "category": "Amenity",
      "h1_title": "Sun Bay South Apartments with Pool",
      "h2_subtitle": "Find apartments with a swimming pool in Sun Bay South. Oasis offers luxurious amenities tailored to enhance your lifestyle.",
      "page_copy": "Looking for apartments with a swimming pool in Sun Bay South? Oasis invites you to dive into a new way of living with our stunning swimming pool. Perfect for leisurely afternoons or an energizing swim, our pool provides a tranquil oasis right in the heart of your community. \n\nOasis, ideally located in bustling Sun Bay South in Tampa, FL, offers more than just a refreshing pool. Our residents enjoy access to a range of amenities, including two lush dog parks and a nearby local park, perfect for outdoor enthusiasts. Join us and embrace a lifestyle enriched by fantastic community features and a welcoming neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sun Bay South Apartments with Pool",
      "seo_description": "Discover apartments with a swimming pool in Sun Bay South at Oasis, where luxurious amenities and a vibrant community unite.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-near-local-park-hillsborough-county-oasis",
      "search_query": "apartments near local park Hillsborough County",
      "category": "Amenity",
      "h1_title": "Apartments near Local Park in Hillsborough",
      "h2_subtitle": "Explore apartments near a local park in Hillsborough County. Oasis offers ideal access to nature and community amenities.",
      "page_copy": "If you're seeking apartments near a local park in Hillsborough County, look no further than Oasis. Our community offers unparalleled access to a nearby park, perfect for enjoying leisurely outdoor activities, picnics, or a brisk morning jog. This proximity to nature allows you to incorporate fresh air and green spaces into your daily routine. \n\nNestled in the Sun Bay South neighborhood of Tampa, FL, Oasis provides a serene escape surrounded by urban conveniences. Residents benefit from a variety of amenities, including a luxurious swimming pool and two spacious dog parks. Experience the perfect balance of city and nature by making Oasis your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments near Local Park in Hillsborough",
      "seo_description": "Find apartments near a local park in Hillsborough County at Oasis. Enjoy nature and community amenities in Sun Bay South, Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-with-dog-parks-tampa-oasis",
      "search_query": "apartments with dog parks Tampa",
      "category": "Amenity",
      "h1_title": "Tampa Apartments with Dog Parks",
      "h2_subtitle": "Discover apartments with dog parks in Tampa. Oasis provides a welcoming environment for you and your pets to enjoy.",
      "page_copy": "Searching for apartments with dog parks in Tampa? Oasis offers an exceptional pet-friendly experience with two dedicated dog parks right on-site. These spaces are perfect for fostering pet interaction, providing a safe environment for your furry friends to play and exercise. \n\nLocated in the heart of Tampa’s Sun Bay South neighborhood, Oasis caters to pet owners seeking convenience and comfort. Besides the fantastic dog parks, residents can also enjoy a refreshing swimming pool and easy access to a local park, enhancing the community's appeal. Make Oasis your home and enjoy a vibrant lifestyle for both you and your pets.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tampa Apartments with Dog Parks",
      "seo_description": "Find apartments with dog parks in Tampa at Oasis. Enjoy pet-friendly amenities, including two dog parks, in the Sun Bay South neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-33611-oasis",
      "search_query": "luxury apartments with pool 33611",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in 33611",
      "h2_subtitle": "Explore luxury apartments with a pool in the 33611 area. Oasis provides an exceptional living experience in Tampa's Sun Bay South.",
      "page_copy": "Discover luxury apartments with a pool in the 33611 zip code at Oasis, where elegance meets comfort. Our exquisite swimming pool serves as the centerpiece of our community, offering a serene retreat for relaxation and social gatherings. Dive into a refreshing lifestyle that redefines apartment living. \n\nNestled in Tampa’s desirable Sun Bay South neighborhood, Oasis combines luxurious amenities with a prime location. Residents not only enjoy the pool but also benefit from our two dog parks and a close-by local park. Elevate your living experience at Oasis, where luxury and convenience come together effortlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in 33611",
      "seo_description": "Find luxury apartments with a pool in the 33611 area at Oasis. Experience exceptional living and amenities in Tampa's Sun Bay South neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "studio-apartments-sun-bay-south-tampa-oasis",
      "search_query": "studio apartments sun bay south tampa",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Sun Bay South Tampa",
      "h2_subtitle": "Discover studio apartments in Tampa's Sun Bay South. Oasis offers modern living in a vibrant neighborhood.",
      "page_copy": "Looking for modern studio apartments in Sun Bay South, Tampa? Oasis provides the perfect blend of style and convenience in this sought-after neighborhood. Our studio apartments are designed to maximize space and functionality, offering a comfortable and practical living experience in a prime location.\n\nOasis isn't just about location; it's about lifestyle. Enjoy the exclusive amenities we offer, including a sparkling swimming pool and two spacious dog parks, ensuring residents and their pets thrive. Additionally, with a local park nearby, outdoor enthusiasts will find endless opportunities for recreation. Choose Oasis for your studio apartment needs and embrace luxury living in Sun Bay South.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Sun Bay South Tampa",
      "seo_description": "Find studio apartments in Sun Bay South Tampa at Oasis. Enjoy modern living with pool, dog parks, and a local park in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-hillsborough-county-oasis",
      "search_query": "one bedroom apartments in hillsborough county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hillsborough County",
      "h2_subtitle": "Explore one bedroom apartments in Hillsborough County at Oasis. Our community offers a stylish and comfortable living experience.",
      "page_copy": "Searching for one bedroom apartments in Hillsborough County? Oasis offers the ideal setting with our thoughtfully designed spaces that blend modern aesthetics with comfort. Situated in Tampa's vibrant Sun Bay South neighborhood, these apartments are perfect for individuals or couples seeking a cozy home.\n\nResidents of Oasis enjoy fantastic community features, including a refreshing swimming pool, two dog parks perfect for furry companions, and access to a local park for leisurely walks. Nestled within the heart of Hillsborough County, Oasis provides the perfect balance of serene living and urban convenience. Experience the best of apartment living at Oasis today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Hillsborough County",
      "seo_description": "Find one bedroom apartments in Hillsborough County at Oasis. Enjoy stylish living with pool and dog parks in Sun Bay South, Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tampa-fl-oasis",
      "search_query": "two bedroom apartments tampa fl",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tampa, FL",
      "h2_subtitle": "Discover spacious two bedroom apartments in Tampa, FL at Oasis. Experience comfort and convenience in a vibrant community.",
      "page_copy": "Looking for spacious two bedroom apartments in Tampa, FL? Oasis offers exceptional living spaces crafted for comfort and style. Our two bedroom layouts are perfect for roommates or small families, providing ample room and modern features in the sought-after Sun Bay South neighborhood.\n\nAt Oasis, residents enjoy a vibrant lifestyle with exclusive amenities such as a sparkling swimming pool, two dog parks, and proximity to a local park. Whether you prefer relaxing by the pool or playing with your pets, there's something for everyone here. Located in the heart of Tampa, FL, Oasis combines urban convenience with serene living. Discover your perfect two bedroom apartment at Oasis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Tampa, FL",
      "seo_description": "Explore two bedroom apartments in Tampa, FL at Oasis. Enjoy a vibrant community with pool, dog parks, and more in Sun Bay South.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-33611-oasis",
      "search_query": "three bedroom apartments near 33611",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 33611",
      "h2_subtitle": "Find spacious three bedroom apartments near the 33611 area at Oasis. Ideal for families seeking comfort and convenience.",
      "page_copy": "If you're searching for roomy three bedroom apartments near 33611, look no further than Oasis. Located in Tampa's serene Sun Bay South neighborhood, our apartments offer generous living spaces designed to accommodate families or roommates with ease. Experience the perfect blend of comfort and functionality in our thoughtfully crafted homes.\n\nApart from spacious interiors, Oasis provides residents with access to an array of amenities including a sparkling swimming pool and two well-maintained dog parks. A local park is also a stone's throw away for those who enjoy outdoor activities. Situated near 33611 in Tampa, Oasis ensures a welcoming and vibrant community environment. Discover family-friendly living at its best today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 33611",
      "seo_description": "Explore three bedroom apartments near 33611 at Oasis. Enjoy family-friendly living with a pool and dog parks in Sun Bay South, Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-near-university-tampa-sun-bay-south-oasis",
      "search_query": "apartments near the university of tampa sun bay south",
      "category": "School",
      "h1_title": "Apartments Near University of Tampa, Sun Bay South",
      "h2_subtitle": "Discover apartments near the University of Tampa in Sun Bay South. Oasis offers a prime location with excellent amenities.",
      "page_copy": "Looking for apartments near the University of Tampa in Sun Bay South? Explore Oasis, where convenience meets comfort in a vibrant community setting. Our location is ideal for students and professionals who wish to enjoy the tranquility of the Sun Bay South neighborhood while remaining close to the bustling university environment.\n\nAt Oasis, residents can unwind by the swimming pool, socialize in our dog parks, or take leisurely strolls in the nearby local park. With easy access to public transport and major highways, commuting is a breeze. Experience a perfect blend of academic rigor and relaxing leisure at Oasis, a place that feels like home near the University of Tampa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Tampa, Sun Bay South",
      "seo_description": "Find apartments near University of Tampa at Oasis in Sun Bay South. Enjoy great amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-near-hca-florida-south-tampa-hospital-oasis",
      "search_query": "apartments near HCA Florida South Tampa Hospital Sun Bay South",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA Florida South Tampa Hospital",
      "h2_subtitle": "Discover apartments near HCA Florida South Tampa Hospital in Sun Bay South. Enjoy a convenient and vibrant community at Oasis.",
      "page_copy": "Are you searching for apartments near HCA Florida South Tampa Hospital? Welcome to Oasis, ideally situated in the picturesque Sun Bay South neighborhood. Our community offers the perfect location for healthcare professionals seeking a short commute and a relaxing environment after a day at work.\n\nOasis features modern living spaces and amenities that enhance your lifestyle. Residents can take advantage of our refreshing swimming pool, two dedicated dog parks, and a local park for outdoor enjoyment. With its central location in Tampa, close to major routes and the hospital, Oasis provides a seamless blend of convenience and comfort. Come home to a welcoming community that caters to both your professional and personal needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA South Tampa Hospital",
      "seo_description": "Explore convenient living at Oasis, near HCA Florida South Tampa Hospital. Enjoy amenities in Sun Bay South close to work and leisure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-near-skyway-park-tampa-fl-oasis",
      "search_query": "apartments near Skyway Park Tampa FL",
      "category": "Park",
      "h1_title": "Apartments Near Skyway Park, Tampa FL",
      "h2_subtitle": "Find your next home near Skyway Park in Tampa, FL. Oasis offers modern living with exceptional amenities in Sun Bay South.",
      "page_copy": "Searching for apartments near Skyway Park, Tampa FL? Discover Oasis, nestled in the vibrant Sun Bay South neighborhood. Our community provides easy access to Skyway Park, making it perfect for those who enjoy outdoor activities and family gatherings in a park setting.\n\nOasis presents a unique living experience with its expansive swimming pool and two dog parks, catering to both relaxation and recreation within the community. Proximity to Skyway Park means that residents can take advantage of outdoor sports facilities and scenic paths just moments from their doorstep. Enjoy modern living blended seamlessly with nature and convenience at Oasis—your ideal home choice in Tampa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Skyway Park, Tampa FL",
      "seo_description": "Discover Oasis near Skyway Park in Tampa FL. Enjoy modern amenities in the Sun Bay South neighborhood, perfect for park enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-near-airport-maintenance-department-tampa-oasis",
      "search_query": "apartments near Airport Maintenance Department Tampa",
      "category": "Transit",
      "h1_title": "Apartments Near Airport Maintenance, Tampa",
      "h2_subtitle": "Explore Oasis, located near the Airport Maintenance Department in Tampa. Discover modern living with convenient access to work and leisure.",
      "page_copy": "Looking for apartments near the Airport Maintenance Department in Tampa? Oasis is the perfect community for professionals seeking proximity to work with a comfortable living environment. Situated in the serene Sun Bay South neighborhood, Oasis offers a quick and easy commute to the airport and surrounding businesses.\n\nExperience a host of amenities including a sparkling swimming pool, two engaging dog parks, and a local park perfect for leisure and relaxation. Designed for both work and play, our community provides the convenience you need and the comfort you desire. Live at Oasis and enjoy the best of both worlds—an efficient work commute and a peaceful setting at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Airport Maintenance, Tampa",
      "seo_description": "Find ideal living at Oasis near Airport Maintenance Department, Tampa. Enjoy modern amenities and a great location in Sun Bay South.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-close-to-skyconnect-rental-car-facility-station-hillsborough-county-oasis",
      "search_query": "apartments close to SkyConnect Rental Car Facility Station Hillsborough County",
      "category": "Transit",
      "h1_title": "Apartments Close to SkyConnect Rental Car Facility",
      "h2_subtitle": "Live near the SkyConnect Rental Car Facility Station in Hillsborough County. Oasis offers a convenient and vibrant living experience.",
      "page_copy": "Discover apartments close to the SkyConnect Rental Car Facility Station in Hillsborough County at Oasis. If you're a frequent traveler or airport employee, our location in Tampa's Sun Bay South neighborhood offers a perfect balance of convenience and comfort.\n\nOasis isn't just about location; it's also about lifestyle. Residents enjoy access to wonderful amenities such as a relaxing swimming pool, two vibrant dog parks, and a nearby local park. These features make Oasis an ideal choice for those seeking community and ease of access to key transportation hubs. Make your life easier by choosing a home that fits your busy lifestyle at Oasis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to SkyConnect Rental Car Facility",
      "seo_description": "Find comfortable living at Oasis, close to SkyConnect Rental Car Facility Station in Hillsborough County. Enjoy modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167733",
      "source": "generator",
      "page_item_url": "apartments-by-skyconnect-economy-parking-station-33611-oasis",
      "search_query": "apartments by SkyConnect Economy Parking Station 33611",
      "category": "Transit",
      "h1_title": "Apartments by SkyConnect Economy Parking 33611",
      "h2_subtitle": "Discover Oasis, located near SkyConnect Economy Parking Station in 33611. Enjoy easy access and a modern lifestyle in Tampa.",
      "page_copy": "Explore the convenience of living in apartments by the SkyConnect Economy Parking Station 33611 at Oasis. Our community in Tampa's Sun Bay South neighborhood offers quick access for frequent flyers and busy professionals needing seamless airport commuting.\n\nOasis combines convenience with amenities, featuring a refreshing swimming pool, two welcoming dog parks, and nearby local green space for relaxation. Choosing Oasis means benefiting from both a strategic location close to SkyConnect and a vibrant, engaging community setting. Experience the ease of travel and the warmth of home all in one at Oasis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by SkyConnect Economy Parking 33611",
      "seo_description": "Live at Oasis, near SkyConnect Economy Parking Station 33611. Enjoy modern amenities and easy airport access in Tampa's vibrant Sun Bay South.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1SOUR3bXNsc0M3SHZ3a1h1ZUVCYkE9PSIsInZhbHVlIjoiSnQ2MDZmWWxiVEdkOW1XMVViRnlpUT09IiwibWFjIjoiMGI0NWE3MjRmZDcxMGY2MDEyYjRkZmY0Mjk4ZjdmYzI2ZmE3MWFmNzMxMjA3ZjRkNzEwZTlkNTE5YzJkYTVlNSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1SOUR3bXNsc0M3SHZ3a1h1ZUVCYkE9PSIsInZhbHVlIjoiSnQ2MDZmWWxiVEdkOW1XMVViRnlpUT09IiwibWFjIjoiMGI0NWE3MjRmZDcxMGY2MDEyYjRkZmY0Mjk4ZjdmYzI2ZmE3MWFmNzMxMjA3ZjRkNzEwZTlkNTE5YzJkYTVlNSJ9",
  "custom_audioeye_site_id": "60913c01-7c31-4f27-85b7-5f52da1525bc",
  "custom_audioeye_site_hash": "ce47f5ca88bcfa13fd5d070fbe187a8d"
};

export const generatedAt = '2026-09-11T19:03:03.104Z';
